var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.72,
    y: 49.06,
    width: 119.58,
    height: 214.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.5,
    y: 55.29,
    width: 108.79,
    height: 202.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "654.29 57.67 545.5 196.06 545.5 55.29 654.29 55.29 654.29 57.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.5,
    y: 113.46,
    width: 111.15,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.5,
    y: 161.6,
    width: 111.15,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.5,
    y: 209.75,
    width: 111.15,
    height: 2.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.55,
    y: 186.12,
    width: 148.68,
    height: 5.5,
    transform: "translate(411.02 788.77) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.45,
    y: 55.29,
    width: 2.49,
    height: 59.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.92,
    y: 55.29,
    width: 2.49,
    height: 59.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.4,
    y: 55.29,
    width: 2.49,
    height: 59.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.88,
    y: 55.29,
    width: 2.49,
    height: 59.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.66,
    y: 45.42,
    width: 5.06,
    height: 219.79,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.36 265.82 660.3 263.88 660.3 45.42 665.36 45.42 665.36 265.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.66,
    y: 43.2,
    width: 129.7,
    height: 5.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.08,
    y: 266.54,
    width: 136.71,
    height: 5.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.3 263.88 668.78 266.54 532.08 266.54 540.72 263.88 660.3 263.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.44,350.75c4.84-2.49,10.53-2.82,15.9-1.93,2.88.48,5.89,1.34,7.85,3.51s2.34,6,.08,7.84a7.56,7.56,0,0,1-4.95,1.25c-4.2-.05-8.86-.79-12.22,1.74-1.91,1.44-3.19,3.84-5.48,4.55a5.41,5.41,0,0,1-6-2.65,9.31,9.31,0,0,1-.67-6.83A10.43,10.43,0,0,1,688.44,350.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.37,329.37c3,4.22,8.7,2.82,11.36.25s3.79-6.32,4.82-9.88c2.34-8.14,4.7-16.68,3-25a13.89,13.89,0,0,0-3.19-6.79,7.25,7.25,0,0,0-6.86-2.29c-2.9.77-4.7,3.61-6,6.31a59.42,59.42,0,0,0-5.88,25.53c0,4.12.47,8.43,2.79,11.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.25,335.43c3.21-3.81,3.82-9.37,2.39-14.14s-4.66-8.83-8.38-12.15a45,45,0,0,0-15-8.85,16,16,0,0,0-6.75-1.14,7.11,7.11,0,0,0-5.66,3.42c-1.57,3-.06,6.66,1.58,9.64a113.67,113.67,0,0,0,9.85,15c3,3.81,6.33,7.56,10.83,9.28s9.17,1.52,11.56-1.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.17,393.07a10,10,0,0,0,.26-1.92c.14-1.4.31-3.15.51-5.24s.57-4.82,1.18-7.68a59.86,59.86,0,0,1,2.79-9.06,33.47,33.47,0,0,1,4.63-8.21,17.38,17.38,0,0,1,5.85-4.86,16.55,16.55,0,0,1,4.93-1.54,9.34,9.34,0,0,0,1.91-.27,8.05,8.05,0,0,0-1.94,0,15,15,0,0,0-5.14,1.33A17.22,17.22,0,0,0,686,360.5a32.57,32.57,0,0,0-4.8,8.37,54.72,54.72,0,0,0-2.77,9.21,64.51,64.51,0,0,0-1,7.78c-.17,2.22-.23,4-.26,5.27A8.46,8.46,0,0,0,677.17,393.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.53,389a4.77,4.77,0,0,0,.05-.89c0-.67,0-1.51,0-2.55,0-2.21,0-5.41.12-9.35.19-7.9.87-16.4,2.18-28.38,1.25-11.27,2.92-24.38,4.68-32.9.38-1.94.76-3.69,1.11-5.22s.64-2.85.92-3.92.44-1.82.59-2.47a.45.45,0,1,0-.15,0c-.19.64-.44,1.44-.74,2.44s-.66,2.37-1,3.89-.82,3.26-1.23,5.2a288.09,288.09,0,0,0-4.91,30.53c-1.32,12-1.91,22.94-2,30.86,0,3.95,0,7.16.13,9.37.07,1,.12,1.87.16,2.54A3.38,3.38,0,0,0,677.53,389Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.58,368a16.92,16.92,0,0,0,0-2.66c-.1-1.71-.33-4.18-.81-7.2a94.86,94.86,0,0,0-2.35-10.5A84.31,84.31,0,0,0,670,335.17a66.11,66.11,0,0,0-12.89-20.08,32.76,32.76,0,0,0-3-2.82c-.47-.39-.88-.78-1.3-1.09l-1.17-.82a19.05,19.05,0,0,0-2.24-1.43c-.13.17,3.17,2.12,7.34,6.55a69.7,69.7,0,0,1,12.57,20,97.88,97.88,0,0,1,4.41,12.31c1.15,3.86,1.92,7.4,2.5,10.39s.86,5.44,1,7.14A17.87,17.87,0,0,0,677.58,368Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "657.2 405.15 659.31 434.09 696.5 434.09 698.61 405.15 657.2 405.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.61,
    y: 393.74,
    width: 49.44,
    height: 11.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.61 432.99 653.61 436.15 655.93 436.15 702.23 436.15 702.23 432.99 653.61 432.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "658.21 441.71 655.93 436.15 700.46 436.15 697.8 441.71 658.21 441.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.92,414.61a1.5,1.5,0,0,1-.17.26l-.56.74L695,418.38l-.1.12-.09-.12L689.51,411h.31l-5.24,7.41-.16.24-.19-.22L678,411.06h.36l-.35.43-5.55,7-.19.23-.17-.24L666.88,411h.3l-6.45,7.36-.12.13-.08-.15c-.85-1.43-1.53-2.57-2-3.39l-.51-.91a1.06,1.06,0,0,1-.16-.32s.08.09.21.29.34.51.58.87l2.12,3.33-.2,0,6.35-7.44.16-.19.15.2c1.6,2.25,3.38,4.73,5.29,7.39h-.36l5.54-7c.12-.15.24-.29.34-.43l.18-.22.18.22,6.2,7.41h-.35c1.91-2.67,3.7-5.15,5.29-7.38l.16-.22.15.22c2.1,3,3.88,5.53,5.21,7.44h-.19l2.25-2.7.61-.7C697.84,414.68,697.91,414.6,697.92,414.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.13,405c0,.12-9.32.23-20.81.23s-20.81-.11-20.81-.23,9.31-.24,20.81-.24S699.13,404.83,699.13,405Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701,436.46c0,.13-10.13.23-22.62.23s-22.61-.1-22.61-.23,10.12-.23,22.61-.23S701,436.33,701,436.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.65,230.8s-7.57-.54-6.87,16.45,2.43,26.05,2.43,26.05-.23,3.77-3.14,3-8.41-4.41-11.13-1.66-1.81,7.2,1.92,12.34,11.49,16.69,12.19,17.74,1,2.95-1.11,2.77-16-4.92-17.88,1.84S59,328.72,60.32,330.13s1.44,2.29.88,3.14-5.09-1.18-9.12-2.37-8.91-1.85-9.65,2.14,4.88,15.67,25.9,27.94l10.11,5,9.57-6.1c19.69-14.32,24.11-26.5,23-30.39s-5.92-2.75-9.81-1.17-8.2,4.06-8.84,3.27-.65-1.68.57-3.21,12.63-15.35,10.12-21.89-15.94-.44-18-.05-2-1.55-1.38-2.65S90.81,290.46,94,285s3.76-9.93.68-12.48-8.07,1.75-10.9,2.77-3.43-2.7-3.43-2.7.82-9.18-.19-26.16S71.5,230.8,71.5,230.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25,246s0,.12,0,.36,0,.6.08,1c.07.94.16,2.29.28,4,.23,3.48.53,8.53.87,14.77.69,12.47,1.5,29.71,2.34,48.75s1.6,36.29,2.22,48.77c.32,6.22.57,11.27.75,14.77.09,1.73.15,3.08.2,4,0,.45,0,.79,0,1.05a3.09,3.09,0,0,1,0,.35s0-.12,0-.35,0-.6-.08-1.05c-.06-.93-.15-2.28-.27-4-.23-3.48-.53-8.53-.88-14.77C77.11,351.27,76.3,334,75.47,315s-1.6-36.28-2.22-48.76c-.32-6.22-.58-11.27-.75-14.77-.09-1.74-.16-3.09-.2-4,0-.45,0-.8,0-1.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,280.11a3,3,0,0,1,.63.52c.39.35.93.88,1.6,1.54,1.34,1.32,3.13,3.2,5.07,5.3l5,5.41,1.5,1.64a3.13,3.13,0,0,1,.53.62,3,3,0,0,1-.63-.52c-.39-.35-.94-.88-1.6-1.55-1.32-1.33-3.09-3.23-5-5.33s-3.65-3.93-5-5.38l-1.52-1.62A3.46,3.46,0,0,1,60.42,280.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,294.81c-.07-.08,3.63-3.95,8.26-8.65s8.46-8.45,8.54-8.38-3.62,4-8.26,8.65S75.78,294.88,75.7,294.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.66,324.11a3.68,3.68,0,0,1,.71-.44l2-1.11c1.66-.94,4-2.25,6.45-3.77s4.7-3,6.29-4.05L93,313.48a3.53,3.53,0,0,1,.72-.42,4.32,4.32,0,0,1-.63.55c-.43.33-1,.8-1.82,1.36-1.56,1.12-3.75,2.62-6.25,4.15s-4.82,2.8-6.53,3.68c-.85.43-1.55.78-2,1A3.3,3.3,0,0,1,75.66,324.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.91,313.86a3,3,0,0,1,.7.33c.44.23,1.06.58,1.83,1,1.54.87,3.65,2.1,6,3.48s4.41,2.65,5.91,3.59c.76.46,1.36.85,1.77,1.12a3.05,3.05,0,0,1,.63.46,3.07,3.07,0,0,1-.7-.33c-.44-.23-1.07-.58-1.84-1-1.54-.87-3.65-2.1-6-3.48s-4.41-2.65-5.92-3.59l-1.77-1.12A3.71,3.71,0,0,1,58.91,313.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.59,339.72a5.88,5.88,0,0,1,.89.44l2.35,1.29c2,1.11,4.7,2.67,7.69,4.41s5.69,3.34,7.64,4.51l2.29,1.41a4.2,4.2,0,0,1,.81.56,5.13,5.13,0,0,1-.89-.43L74,350.61c-2-1.11-4.7-2.67-7.69-4.41s-5.69-3.34-7.64-4.51l-2.29-1.4A3.67,3.67,0,0,1,55.59,339.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83,351.89a6.25,6.25,0,0,1,.88-.59l2.46-1.5c2.07-1.26,4.93-3,8-5s5.88-3.92,7.87-5.31l2.36-1.64a5.11,5.11,0,0,1,.9-.57,6.43,6.43,0,0,1-.81.69c-.53.42-1.31,1-2.29,1.74-2,1.45-4.7,3.39-7.82,5.41s-6,3.75-8.11,5c-1,.6-1.91,1.08-2.52,1.39A5.84,5.84,0,0,1,76.83,351.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.03 369.34 64.05 369.34 73.18 438.46 82.9 438.46 92.03 369.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5,377.84s0,.1.15.24a1.8,1.8,0,0,0,.68.49,3.36,3.36,0,0,0,3-.37c1.13-.62,2.11-1.84,3.63-2.38a7.9,7.9,0,0,1,5.14.1,22,22,0,0,1,4.79,2.32,33.44,33.44,0,0,0,3.9,2.09,10.63,10.63,0,0,0,2.87.83,5.75,5.75,0,0,0,.81.06c.19,0,.29,0,.29,0A14.61,14.61,0,0,1,86.87,380a36.11,36.11,0,0,1-3.81-2.15,21.25,21.25,0,0,0-4.87-2.4,8.23,8.23,0,0,0-5.43-.06,7.2,7.2,0,0,0-2.05,1.27,17,17,0,0,1-1.6,1.24,3.26,3.26,0,0,1-2.72.47A2.78,2.78,0,0,1,65.5,377.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.52,390.57s.22-.29.66-.74a6.17,6.17,0,0,1,2.24-1.42,10.12,10.12,0,0,1,3.89-.59,41.25,41.25,0,0,1,4.87.67,16.58,16.58,0,0,0,5,.2,13.2,13.2,0,0,0,3.92-1.12,12.46,12.46,0,0,0,2.36-1.4,3.39,3.39,0,0,0,.75-.67A27.3,27.3,0,0,1,87,387.28a14.48,14.48,0,0,1-3.84,1,17.29,17.29,0,0,1-4.86-.24,36.66,36.66,0,0,0-4.93-.64,9.9,9.9,0,0,0-4,.71,5.81,5.81,0,0,0-2.25,1.6,3.55,3.55,0,0,0-.42.62C66.54,390.48,66.51,390.56,66.52,390.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.86,397.38a2.57,2.57,0,0,0-.77-.4,8.52,8.52,0,0,0-2.32-.49,14.6,14.6,0,0,0-3.51.2c-1.3.21-2.7.57-4.17.88a17.43,17.43,0,0,1-4.17.47,9,9,0,0,1-3.3-.71,7.62,7.62,0,0,1-2.51-1.87,2.12,2.12,0,0,0,.47.73,5.93,5.93,0,0,0,1.9,1.43,9,9,0,0,0,3.43.84,17,17,0,0,0,4.27-.44c1.49-.32,2.88-.69,4.15-.92a16.08,16.08,0,0,1,3.42-.29A13.22,13.22,0,0,1,88.86,397.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,407a4.54,4.54,0,0,1,2.72-.27,12.64,12.64,0,0,1,2.84,1.06,10.79,10.79,0,0,0,3.69,1,11,11,0,0,0,6.69-1.55,9,9,0,0,0,1.67-1.28c.34-.36.52-.57.49-.59a23.51,23.51,0,0,1-2.32,1.59,11.5,11.5,0,0,1-6.49,1.38c-2.65-.15-4.68-1.73-6.52-1.94a4.09,4.09,0,0,0-2.11.18A1.45,1.45,0,0,0,69,407Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,420.24a5.52,5.52,0,0,0,2.34-.47c1.4-.47,3.14-1.54,5.18-2.35a8.28,8.28,0,0,1,3-.62,5.47,5.47,0,0,1,2.39.54,5.41,5.41,0,0,1,1.73,1.49,1.33,1.33,0,0,0-.27-.59,3.68,3.68,0,0,0-1.31-1.18,5.4,5.4,0,0,0-2.54-.69,8.59,8.59,0,0,0-3.14.62c-2.1.84-3.79,1.95-5.13,2.48S70.54,420.16,70.55,420.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.92,426.41a6.59,6.59,0,0,0,1.78.58,32.74,32.74,0,0,0,4.42.74,31.39,31.39,0,0,0,4.49.13,6.23,6.23,0,0,0,1.85-.22c0-.14-2.83,0-6.29-.36S72,426.28,71.92,426.41Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.47,440.37c0,.14-149.35.26-333.53.26s-333.57-.12-333.57-.26,149.32-.27,333.57-.27S709.47,440.22,709.47,440.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.11,
    y: 340.3,
    width: 7.31,
    height: 87.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83,340.3H127.22a11.36,11.36,0,0,1,11.35-11.36h81.91a11.36,11.36,0,0,1,11.35,11.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,340.52a38.34,38.34,0,0,1-6.42.27,38.24,38.24,0,0,1-6.42-.27,38.24,38.24,0,0,1,6.42-.27A38.34,38.34,0,0,1,187.19,340.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,435.87h-1a31.13,31.13,0,0,0-62.25,0h-1a32.16,32.16,0,1,1,64.31,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79,435.29a4.83,4.83,0,1,1-4.83-4.83A4.82,4.82,0,0,1,153.79,435.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.27,435.51a4.82,4.82,0,1,1-4.82-4.82A4.82,4.82,0,0,1,217.27,435.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.45,427.93c0,.15-14,.27-31.25.27s-31.25-.12-31.25-.27,14-.27,31.25-.27S212.45,427.78,212.45,427.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,253.54v64.51a15.31,15.31,0,0,0,15.31,15.32h49.71l-6.75-79.83a6.83,6.83,0,0,0-6.83-6.83H131.66A6.82,6.82,0,0,0,124.84,253.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.41,328.94a3.66,3.66,0,0,1-.56-.61c-.35-.41-.84-1-1.43-1.87a30.05,30.05,0,0,1-3.88-7.76,30.82,30.82,0,0,1-1.33-5.86A54.81,54.81,0,0,1,135,306c0-4.84,0-10.15,0-15.73,0-11.14.06-21.22.08-28.58,0-3.62.06-6.57.08-8.66,0-1,0-1.77,0-2.36a4,4,0,0,1,.05-.82,4,4,0,0,1,.05.82c0,.59,0,1.37,0,2.36,0,2.09.05,5,.08,8.66,0,7.36,0,17.44.08,28.58,0,5.58,0,10.89,0,15.73a55.7,55.7,0,0,0,.21,6.83,31.31,31.31,0,0,0,5,13.56c.56.85,1,1.5,1.35,1.93S142.42,328.93,142.41,328.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.47,328.75a10.56,10.56,0,0,1-1.58.11l-4.3.11c-3.64.08-8.66.14-14.21.18l-7.82.05a26.75,26.75,0,0,0-6.3.57,10.4,10.4,0,0,0-3.8,1.82c-.81.6-1.17,1.05-1.21,1s.07-.12.25-.33a6.36,6.36,0,0,1,.83-.83,9.82,9.82,0,0,1,3.84-2,25.61,25.61,0,0,1,6.38-.7c2.4-.06,5-.06,7.82-.09,5.55,0,10.58,0,14.22,0l4.31.05A8.18,8.18,0,0,1,169.47,328.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,219.75l-4.85,5-9.71-10.34,3.23-5.53c.17-.71.35-1.5.52-2.39a9.7,9.7,0,0,0,.06-3.18,14.88,14.88,0,0,0-1-3.83c-.56-1.07.44-2.28,1.41-1.79s2.59,3.4,2.81,7.31,3.74-1.07,5-2.86,5.61-7.13,6.47-7.15c1.26,0,1.53,1.34.18,3.1s-5,7.32-4.06,8h0a4.74,4.74,0,0,1,4.8,2.7c.83,1.76,1.74,4.25.88,5.33A61.73,61.73,0,0,1,280.26,219.75Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.7 214.38 230.83 243.09 244.83 262.65 275.41 224.73 265.7 214.38",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.69,206.9a12.6,12.6,0,0,1-1.73,1.94l-2,2L278.78,212a2.46,2.46,0,0,1-1.74.87,1.22,1.22,0,0,1-1-.55,1.66,1.66,0,0,1-.25-1,2.8,2.8,0,0,1,.82-1.61,24.65,24.65,0,0,1,2-2,9.5,9.5,0,0,1,2.11-1.55,21.81,21.81,0,0,1-1.86,1.82c-.57.56-1.23,1.25-1.92,2a2.39,2.39,0,0,0-.67,1.32.88.88,0,0,0,.73,1,2.11,2.11,0,0,0,1.36-.72l1.2-1.15,2.07-1.93A12.41,12.41,0,0,1,283.69,206.9Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,209.42a11.34,11.34,0,0,1-1.67,1.88l-1.91,1.94c-.37.36-.72.74-1.17,1.13a3.08,3.08,0,0,1-.79.48,1.36,1.36,0,0,1-1.05,0,1.51,1.51,0,0,1-.74-1.77,3.37,3.37,0,0,1,.91-1.45,24,24,0,0,1,2-1.9,8.89,8.89,0,0,1,2-1.49,19.81,19.81,0,0,1-1.78,1.76c-.55.54-1.2,1.19-1.87,2a3.15,3.15,0,0,0-.77,1.25,1,1,0,0,0,.46,1.17c.4.19.91-.08,1.31-.41s.78-.73,1.15-1.08l2-1.85A11.83,11.83,0,0,1,285,209.42Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,211.81a11.07,11.07,0,0,1-1.59,1.81l-1.83,1.86a8.39,8.39,0,0,1-1.19,1.05,1.86,1.86,0,0,1-.87.33,1.24,1.24,0,0,1-1-.35,1.67,1.67,0,0,1-.28-1.82,4.45,4.45,0,0,1,1-1.31,23.35,23.35,0,0,1,1.9-1.81,8.32,8.32,0,0,1,2-1.42,16.93,16.93,0,0,1-1.71,1.69c-.53.51-1.15,1.14-1.8,1.87a4.34,4.34,0,0,0-.84,1.17,1.17,1.17,0,0,0,.18,1.26.94.94,0,0,0,1.2,0,7.28,7.28,0,0,0,1.12-1l1.91-1.77A11.1,11.1,0,0,1,286.34,211.81Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,217.84a10.11,10.11,0,0,1,.24-1.46,7.77,7.77,0,0,0-.35-3.45,7.68,7.68,0,0,0-1.88-2.92c-.65-.63-1.14-.93-1.1-1a2.87,2.87,0,0,1,1.34.73,6.65,6.65,0,0,1,2.13,3,6.75,6.75,0,0,1,.22,3.69C275.65,217.37,275.33,217.87,275.27,217.84Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.32,246.87l5.2,52.24-64.16,1.39.35-42.05-4.64-36.26c3-17,26.82-18.13,26.82-18.13l18.67-.3a32.88,32.88,0,0,1,18.36,4.07s19,10.32,18.77,36.52",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,213.36c-5.6,5.35-11,16.09-9,37.61l29.84-1.23L168,220.3a10,10,0,0,0-3.85-7.6h0A12.47,12.47,0,0,0,148,213.36Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,291.63a2.85,2.85,0,0,1-.53.4,8.8,8.8,0,0,1-1.74.81,13.6,13.6,0,0,1-7,.27c-2.94-.53-6.2-2-9.94-3a33.35,33.35,0,0,0-12.5-.78c-4.47.52-8.45,2.17-12.09,3.58a37.75,37.75,0,0,1-10,2.8,16.51,16.51,0,0,1-7-.68,11.71,11.71,0,0,1-1.74-.79,2.64,2.64,0,0,1-.56-.36s.8.45,2.37,1a16.83,16.83,0,0,0,6.86.51,38.38,38.38,0,0,0,9.88-2.87c3.61-1.44,7.65-3.13,12.19-3.66a33.46,33.46,0,0,1,12.69.83c1.91.5,3.65,1.16,5.29,1.73a37.9,37.9,0,0,0,4.6,1.36,13.91,13.91,0,0,0,6.85-.1A13.54,13.54,0,0,0,210.4,291.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.43,291.26l.26.2a23.68,23.68,0,0,0,24.81,2.39c3-1.55,5.69-3.77,8.9-4.87,4.55-1.55,9.53-.65,14.28.11s10.42,1.27,14.72-.89l-.56-6.59-62.25,1.62"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.51,436.68l-.15-6.24-16.69.57.1,9.75,1,.07c4.58.26,23.34,1,26.41.09C224.64,439.89,210.51,436.68,210.51,436.68Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.8,440.64a5.93,5.93,0,0,0-2-3.66,4.85,4.85,0,0,0-4.07-1.12l.06,4.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.41,438.49s5,1.44,4.33,2.25-19.6.77-28,0l0-.37,22.15.24S216.45,438.53,217.41,438.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.53,440.37l.29,0,.82,0,3,.14c2.55.09,6.08.18,10,.2s7.43-.06,10-.14l3-.12.82,0,.29,0a1.29,1.29,0,0,0-.29,0h-.82l-3,0c-2.56,0-6.08.09-10,.07s-7.42-.08-10-.14l-3-.07h-1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,440.89a6.74,6.74,0,0,1,.57-1.44,7.32,7.32,0,0,1,1-1.16,2.71,2.71,0,0,0-1.6,2.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,438.39c.05,0,.29-.26.53-.64s.4-.71.35-.74-.28.25-.52.63A2,2,0,0,0,211,438.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,437.67s.3-.13.59-.39.49-.5.45-.54-.3.14-.59.39S209.65,437.63,209.69,437.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,436.1a3.84,3.84,0,0,0,1.74,0,2.18,2.18,0,0,0-.87-.11A1.82,1.82,0,0,0,208.84,436.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,435a1.75,1.75,0,0,0,1,.29,1.77,1.77,0,0,0,1-.13,4.83,4.83,0,0,0-1-.07A6.36,6.36,0,0,0,208.55,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,436.94a3.22,3.22,0,0,0,1.07,0,5.69,5.69,0,0,0,1.14-.24,3.46,3.46,0,0,0,.65-.27.55.55,0,0,0,.26-.33.42.42,0,0,0-.16-.43,2,2,0,0,0-2.42.57,1.84,1.84,0,0,0-.35.71.71.71,0,0,0,0,.29,2.94,2.94,0,0,1,.49-.91,1.83,1.83,0,0,1,.91-.59,1.68,1.68,0,0,1,1.28.09c.17.12.1.32-.09.43a2.66,2.66,0,0,1-.6.26,6.58,6.58,0,0,1-1.1.28C212,436.91,211.6,436.9,211.6,436.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.88,437a1.1,1.1,0,0,0,.12-.74,1.63,1.63,0,0,0-.29-.78,1.07,1.07,0,0,0-.89-.55.44.44,0,0,0-.33.49,1.3,1.3,0,0,0,.18.48,3,3,0,0,0,.51.65,1.46,1.46,0,0,0,.61.43s-.21-.19-.51-.53a3.93,3.93,0,0,1-.44-.64c-.15-.23-.25-.63,0-.68s.54.24.7.46a1.71,1.71,0,0,1,.3.69A4.93,4.93,0,0,1,211.88,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88,435.83a11.2,11.2,0,0,1,1.23,0,5.21,5.21,0,0,1,4.35,3.48c.25.72.27,1.2.31,1.19a.94.94,0,0,0,0-.33,4,4,0,0,0-.18-.9,5.06,5.06,0,0,0-1.68-2.48,5.12,5.12,0,0,0-2.78-1.1,4.34,4.34,0,0,0-.92,0C194,435.78,193.88,435.81,193.88,435.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,439a9.79,9.79,0,0,0,2.43.25,9.37,9.37,0,0,0,2.43-.19c0-.06-1.09,0-2.43,0S201.9,439,201.89,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,439s.09.23.2.48.17.47.23.47.09-.27,0-.55S198.67,439,198.63,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.41,437.48s.07.21.24.38.34.29.38.25-.07-.21-.24-.39S197.45,437.44,197.41,437.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,436.77c0,.06.24.06.48.15s.42.21.46.18-.09-.27-.4-.37S195.64,436.72,195.65,436.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,436.44c0,.05.08.14.22.19s.26.06.28,0-.07-.14-.21-.19S194.42,436.39,194.4,436.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.71 434.92 210.49 434.22 210.49 433.54 193.67 433.54 193.71 434.92",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,435.79l-.16-6.39L248,430l.1,10,1,.07c4.7.27,23.9,1,27,.1C279.68,439.07,265.23,435.79,265.23,435.79Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.26,439.84a6,6,0,0,0-2.06-3.74A4.93,4.93,0,0,0,248,435l.06,4.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.29,437.65s5.06,1.47,4.43,2.3-20.06.79-28.63,0l0-.38,22.67.25S271.3,437.69,272.29,437.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85,439.57l.29,0,.84.06,3.09.14c2.62.1,6.23.19,10.22.2s7.6-.05,10.21-.13l3.09-.12.84-.05.3,0h-1.14l-3.09.06c-2.62,0-6.23.09-10.21.08s-7.6-.08-10.21-.15l-3.1-.07-.84,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.77,440.1a7.89,7.89,0,0,1,.59-1.48,7,7,0,0,1,1.05-1.18,2.78,2.78,0,0,0-1.64,2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,437.54c.05,0,.29-.26.54-.65s.41-.74.36-.77-.29.27-.54.66S265.71,437.51,265.76,437.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,436.81s.31-.14.6-.4.5-.51.47-.56-.31.14-.6.4S264.34,436.76,264.38,436.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,435.2a2,2,0,0,0,.88.11,1.91,1.91,0,0,0,.89-.09,2,2,0,0,0-.88-.11A1.91,1.91,0,0,0,263.52,435.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,434.06a1.69,1.69,0,0,0,1,.29,1.72,1.72,0,0,0,1-.13,5,5,0,0,0-1-.07A6.79,6.79,0,0,0,263.22,434.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,436.05a2.87,2.87,0,0,0,1.09,0,6.88,6.88,0,0,0,1.17-.25,3.09,3.09,0,0,0,.67-.28.65.65,0,0,0,.27-.33.43.43,0,0,0-.17-.44,2,2,0,0,0-2.48.58,2,2,0,0,0-.36.73.71.71,0,0,0,0,.29,3.36,3.36,0,0,1,.5-.93,1.94,1.94,0,0,1,.94-.6,1.63,1.63,0,0,1,1.3.09c.18.13.11.33-.09.45a4.14,4.14,0,0,1-.61.26,8.2,8.2,0,0,1-1.13.29C266.76,436,266.34,436,266.34,436.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,436.11a1.05,1.05,0,0,0,.13-.76,1.66,1.66,0,0,0-.3-.8,1.09,1.09,0,0,0-.9-.56.43.43,0,0,0-.34.51,1.15,1.15,0,0,0,.18.48,3.18,3.18,0,0,0,.52.67,1.63,1.63,0,0,0,.62.44s-.22-.19-.52-.54a4,4,0,0,1-.45-.66c-.15-.23-.25-.65,0-.7s.55.25.72.47a1.81,1.81,0,0,1,.31.71A3.33,3.33,0,0,1,266.62,436.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.21,434.92a11.6,11.6,0,0,1,1.25,0,5.56,5.56,0,0,1,2.74,1.14,5.48,5.48,0,0,1,1.71,2.43c.26.73.28,1.22.32,1.21a1,1,0,0,0,0-.34,4.27,4.27,0,0,0-.18-.92,5.18,5.18,0,0,0-4.57-3.66,4.54,4.54,0,0,0-.94,0C248.32,434.87,248.2,434.9,248.21,434.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,438.19a9.74,9.74,0,0,0,2.49.25,9.92,9.92,0,0,0,2.49-.19c0-.06-1.12,0-2.49,0S256.41,438.13,256.4,438.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,438.17c0,.05.09.24.2.5s.18.48.23.47.09-.27,0-.56S253.1,438.13,253.07,438.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,436.61s.07.21.25.39.35.29.39.26-.07-.22-.24-.4S251.86,436.57,251.81,436.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,435.89c0,.06.24.05.49.14s.43.22.47.19-.1-.28-.41-.38S250,435.83,250,435.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.74,435.55c0,.05.08.14.22.19s.27.06.29,0-.08-.14-.22-.2S248.76,435.49,248.74,435.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.03 433.99 265.2 433.27 265.2 432.57 247.99 432.57 248.03 433.99",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.93,299.72l-68.17-.86L197,330.91l39.1.3a4.94,4.94,0,0,1,4.9,4.73l4.2,98,26.37-2-2.67-112.22a20.69,20.69,0,0,0-18-20Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.15,333.53l2.9,101.25,32.7-2.33s-1.81-95.5-4.25-121.72c-1.68-17.94-70.14-10.23-70.14-10.23-1,35.73,38.79,33,38.79,33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.76,325.61a38.79,38.79,0,0,1,.52,9.13,19.28,19.28,0,0,1-.53-4.55A19.75,19.75,0,0,1,185.76,325.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,299.05a2.17,2.17,0,0,1,.58,0l1.67,0c1.45,0,3.54.11,6.13.26s5.67.37,9.07.88A26.43,26.43,0,0,1,212.53,304a11.73,11.73,0,0,1,2.25,2,7.65,7.65,0,0,1,1.47,2.52,25.6,25.6,0,0,1,1.09,5.31,87.42,87.42,0,0,1,.37,9.11c0,2.53,0,4.61,0,6.13,0,.67,0,1.22,0,1.67a2.59,2.59,0,0,1,0,.58,2.3,2.3,0,0,1-.09-.58c0-.38-.08-.94-.11-1.66-.08-1.45-.13-3.55-.18-6.14s-.1-5.67-.49-9.05a25.8,25.8,0,0,0-1.08-5.19,8.74,8.74,0,0,0-3.54-4.22,26.59,26.59,0,0,0-10.28-3.72c-3.37-.53-6.44-.8-9-1l-6.11-.43-1.67-.14A3.91,3.91,0,0,1,184.57,299.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,251a2.09,2.09,0,0,0,.52,0l1.49,0,5.48-.2c4.63-.2,11-.5,18.07-.86l3.62-.19h.24v-.24c0-6.18-.07-11.64-.09-15.65,0-1.91-.05-3.47-.07-4.63,0-.5,0-.92,0-1.25a1.89,1.89,0,0,0,0-.44,1.18,1.18,0,0,0-.05.44c0,.33,0,.75,0,1.25,0,1.16-.05,2.72-.08,4.63,0,4-.05,9.47-.08,15.65l.23-.25-3.61.18c-7.06.37-13.44.73-18.07,1l-5.47.37-1.48.12A1.71,1.71,0,0,0,138.94,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.79,208.64a18.15,18.15,0,0,1,3.48-.11,12.35,12.35,0,0,1,7.38,3.54,14.59,14.59,0,0,1,3.79,7.33c.43,2.12.34,3.48.44,3.48a3.21,3.21,0,0,0,.1-.95,13.39,13.39,0,0,0-.19-2.59,14.15,14.15,0,0,0-3.78-7.63,12.13,12.13,0,0,0-7.71-3.54,9.5,9.5,0,0,0-2.6.18A2.63,2.63,0,0,0,152.79,208.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35,223.69a14.83,14.83,0,0,0-.18,2.82c0,1.75,0,4.2,0,6.89s.11,4.85.15,6.74c0,1.07,0,1.85,0,2.61,0-.87,0-1.75,0-3,0-1.89.09-4.2.15-6.75s0-4.89,0-6.59A15,15,0,0,0,206.35,223.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.41,251l.71,29.42a11.19,11.19,0,0,0,13.56,10.33l44.47-12.3L204.49,262l-41.59,8-.53-20Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,277.17a2.62,2.62,0,0,1-.14-1.41,6.78,6.78,0,0,1,1.1-3.24,6.92,6.92,0,0,1,2.54-2.3c.79-.4,1.33-.48,1.35-.42a8.51,8.51,0,0,0-4.85,7.37Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,231.25s0,.12,0,.35a7.11,7.11,0,0,1-.26,1,8.54,8.54,0,0,1-2,3.19,8.8,8.8,0,0,1-5,2.56,14.81,14.81,0,0,1-6.77-1,25.5,25.5,0,0,0-6.5-1.66,9,9,0,0,0-5.19,1.28,9.57,9.57,0,0,0-2.74,2.43c-.53.7-.75,1.14-.79,1.11s0-.12.12-.33a5.78,5.78,0,0,1,.51-.9,8.93,8.93,0,0,1,2.71-2.62,9.16,9.16,0,0,1,5.4-1.45,24.79,24.79,0,0,1,6.64,1.64,14.82,14.82,0,0,0,6.54,1,8.66,8.66,0,0,0,4.78-2.35,9.15,9.15,0,0,0,2.09-3C167.45,231.72,167.55,231.24,167.6,231.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,213a2.56,2.56,0,0,1-.52.66,11.86,11.86,0,0,1-1.71,1.52A14.69,14.69,0,0,1,148.17,217a12.14,12.14,0,0,1-2-1.06,2.31,2.31,0,0,1-.66-.52c.05-.08,1,.59,2.82,1.24a15.48,15.48,0,0,0,14.07-1.73C163.94,213.85,164.74,213,164.81,213Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,224a8.6,8.6,0,0,0-1.57-1.53,8.72,8.72,0,0,0-5.66-1.43c-2.53.14-5.32,1.48-8.14,3.3-1.42.89-2.89,1.9-4.51,2.8a17.32,17.32,0,0,1-5.38,2.05,11,11,0,0,1-5.73-.54,26.92,26.92,0,0,1-4.77-2.4c-2.87-1.77-5.53-3.31-8-3.7a8.28,8.28,0,0,0-5.73,1,7.55,7.55,0,0,0-1.63,1.46s.08-.18.3-.49a5.52,5.52,0,0,1,1.22-1.14,8.24,8.24,0,0,1,5.9-1.18c2.61.35,5.35,1.91,8.22,3.65a28.57,28.57,0,0,0,4.7,2.33,10.55,10.55,0,0,0,5.48.51,17.15,17.15,0,0,0,5.21-2c1.6-.88,3.06-1.88,4.51-2.77,2.85-1.81,5.73-3.16,8.37-3.26a8.77,8.77,0,0,1,5.8,1.63,5.66,5.66,0,0,1,1.16,1.2A1.94,1.94,0,0,1,220.4,224Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.35,208.2a7.55,7.55,0,0,1-2.1,1.23,19,19,0,0,1-11.57,1.26,7.66,7.66,0,0,1-2.32-.75,30,30,0,0,0,8.15.51A30.3,30.3,0,0,0,206.35,208.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.11,252.7s-.4-.35-1.2-.83a8.27,8.27,0,0,0-3.76-1.06,13.34,13.34,0,0,0-5.7,1.11c-2.07.8-4.21,2-6.63,3a23.65,23.65,0,0,1-13.07,1.67,14.68,14.68,0,0,1-3.84-1.25,8.69,8.69,0,0,1-1-.53c-.21-.13-.32-.2-.31-.22a21.74,21.74,0,0,0,5.17,1.63,24.29,24.29,0,0,0,12.82-1.78c2.37-1,4.53-2.19,6.65-3a13.23,13.23,0,0,1,5.9-1A7.89,7.89,0,0,1,197,251.7a5.07,5.07,0,0,1,.85.7C198,252.58,198.12,252.69,198.11,252.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,216.75h0A10.64,10.64,0,0,0,192.65,206c0-3.7-.1-6.9-.1-6.9s8.55-.79,9.18-9.25.36-28,.36-28h0a29.51,29.51,0,0,0-29.81,1.9l-1.31.89.4,41.6A10.65,10.65,0,0,0,182,216.75Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,199a19.65,19.65,0,0,1-10.84-3.82s2.23,6.26,10.73,6Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,174c-.15-.05-5.35-.73-4.86,5.41s6.53,3.62,6.53,3.44S173.15,174,173.15,174Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.76,180.8s-.1.09-.27.19a1.12,1.12,0,0,1-.8.08,2.67,2.67,0,0,1-1.42-2.28,3.61,3.61,0,0,1,.18-1.56,1.23,1.23,0,0,1,.74-.88.53.53,0,0,1,.65.24c.1.16.07.29.1.3s.13-.12.06-.37a.73.73,0,0,0-.27-.36.83.83,0,0,0-.61-.11,1.51,1.51,0,0,0-1,1,3.57,3.57,0,0,0-.23,1.74,2.76,2.76,0,0,0,1.77,2.53,1.13,1.13,0,0,0,1-.24C172.76,181,172.78,180.81,172.76,180.8Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.15,163.28c2.09-.51,2.84-3.64,2.77-5.79a6,6,0,0,0-3.53-5,7.7,7.7,0,0,0-6.27.1,6.77,6.77,0,0,0-13.37.37c-.2-1.63-2.05-2.55-3.7-2.65a5.4,5.4,0,0,0-4.46,1.64,3.32,3.32,0,0,0,0,4.46,7.55,7.55,0,0,0-5.26,1.26,5.57,5.57,0,0,0-2.34,4.75,4.43,4.43,0,0,0,3.31,4c.62.13.78-.29,1.11.25a5.23,5.23,0,0,1,.24,1.77,24.08,24.08,0,0,0,.35,5.8,2.35,2.35,0,0,1,3,1.32,6.82,6.82,0,0,1,.34,3.54c.52.79,1.83.55,2.4-.2a4.46,4.46,0,0,0,.62-2.7l.12-9.8a3.34,3.34,0,0,0,3.16,0,3.29,3.29,0,0,0,1.66-2.68,6.47,6.47,0,0,0,10-1.21,15.24,15.24,0,0,0,3.22,2.13,5.18,5.18,0,0,0,3.76.33c1.22-.42,2.94-.32,2.92-1.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.86,175.37a1.19,1.19,0,0,1-1.15,1.2,1.13,1.13,0,0,1-1.22-1.07,1.19,1.19,0,0,1,1.14-1.2A1.15,1.15,0,0,1,199.86,175.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.12,174c-.15.15-1.05-.51-2.33-.51s-2.21.64-2.35.49.08-.35.49-.65a3.25,3.25,0,0,1,1.88-.58,3.08,3.08,0,0,1,1.85.6C200.06,173.69,200.19,174,200.12,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35,175.67a1.19,1.19,0,0,1-1.15,1.2A1.13,1.13,0,0,1,185,175.8a1.18,1.18,0,0,1,1.14-1.2A1.16,1.16,0,0,1,187.35,175.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,174.28c-.15.15-1.05-.51-2.33-.51s-2.21.64-2.35.48.08-.34.49-.64a3.25,3.25,0,0,1,1.88-.58,3.08,3.08,0,0,1,1.85.6C187.5,173.93,187.63,174.21,187.56,174.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,183.75a8.62,8.62,0,0,1,2.08-.37c.33,0,.63-.1.69-.32a1.63,1.63,0,0,0-.22-1c-.3-.79-.63-1.62-1-2.49a43.22,43.22,0,0,1-2.17-6.49,42.46,42.46,0,0,1,2.69,6.3c.32.88.63,1.71.92,2.5a2,2,0,0,1,.17,1.28.83.83,0,0,1-.54.48,2.43,2.43,0,0,1-.55.08A8.41,8.41,0,0,1,192.19,183.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,184.63c.21,0,.22,1.38,1.4,2.36s2.67.84,2.68,1-.33.27-1,.29a3.48,3.48,0,0,1-2.23-.78,3,3,0,0,1-1.08-2C188.19,185,188.34,184.63,188.43,184.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89,169.27c-.13.35-1.4.18-2.9.36s-2.71.59-2.91.28c-.09-.15.12-.47.61-.81a4.8,4.8,0,0,1,2.16-.76,4.94,4.94,0,0,1,2.26.27C187.67,168.83,187.94,169.1,187.89,169.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.65,170.34c-.23.29-1.11,0-2.17,0s-1.95.19-2.16-.11.05-.44.44-.72a3.07,3.07,0,0,1,1.76-.47,3,3,0,0,1,1.73.58C199.62,169.9,199.75,170.2,199.65,170.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.48,161.5a2.28,2.28,0,0,0,.4.91,4.28,4.28,0,0,0,2.48,1.33,10,10,0,0,0,4.52.18,5.34,5.34,0,0,0,2.44-1.32,2.83,2.83,0,0,0,.92-2.74,1.34,1.34,0,0,0-1.15-.88.91.91,0,0,0-1,.86,3.1,3.1,0,0,0,2,2.75,4.79,4.79,0,0,0,3.84,0,7.91,7.91,0,0,0,3.26-2.64,3.77,3.77,0,0,0,.77-2,1.5,1.5,0,0,0-1.08-1.52,1.92,1.92,0,0,0-1.93.51,2.47,2.47,0,0,0-.54,2.05,4.18,4.18,0,0,0,3.24,3,6.89,6.89,0,0,0,4.81-.54,6.42,6.42,0,0,0,3.24-3.54,2.44,2.44,0,0,0-.17-2.18,1.37,1.37,0,0,0-1.82-.53,1.91,1.91,0,0,0-.91,1.81,3.63,3.63,0,0,0,.91,2,6.33,6.33,0,0,0,3.77,2.15c2.84.48,5.85-1.25,6.57-3.7a2.36,2.36,0,0,0-1.38-2.9,2,2,0,0,0-2.4,1.62,3.57,3.57,0,0,0,.72,2.9,4.53,4.53,0,0,0,2.25,1.57,4.06,4.06,0,0,0,4.16-1,4.59,4.59,0,0,0,1.37-2.47,9.07,9.07,0,0,0,.11-1,3,3,0,0,1,0,1,4.65,4.65,0,0,1-1.34,2.6,4.33,4.33,0,0,1-1.83,1.11,4.26,4.26,0,0,1-2.55,0,4.92,4.92,0,0,1-2.44-1.65,3.93,3.93,0,0,1-.81-3.18,2.65,2.65,0,0,1,1-1.55,2.13,2.13,0,0,1,1.9-.37,2.77,2.77,0,0,1,1.68,3.39,5.56,5.56,0,0,1-2.68,3.24,6.69,6.69,0,0,1-4.39.82,6.79,6.79,0,0,1-4.07-2.3,4.13,4.13,0,0,1-1-2.28,2.4,2.4,0,0,1,1.16-2.29,1.73,1.73,0,0,1,1.39-.16,2.1,2.1,0,0,1,1.1.84,2.92,2.92,0,0,1,.24,2.63,6.92,6.92,0,0,1-3.5,3.85,7.32,7.32,0,0,1-5.17.56,5.73,5.73,0,0,1-2.31-1.19,3.8,3.8,0,0,1-1.31-2.25,3,3,0,0,1,.68-2.47A2.38,2.38,0,0,1,183,156a1.91,1.91,0,0,1,1.07.76,2.14,2.14,0,0,1,.36,1.24,4.22,4.22,0,0,1-.87,2.23,8.46,8.46,0,0,1-3.48,2.79,5.24,5.24,0,0,1-4.2-.07,4.37,4.37,0,0,1-1.6-1.28,2.78,2.78,0,0,1-.61-1.91,1.41,1.41,0,0,1,.48-.92,1.3,1.3,0,0,1,1-.27,1.69,1.69,0,0,1,1.45,1.14,3.15,3.15,0,0,1-1,3.1,5.65,5.65,0,0,1-2.6,1.36,10,10,0,0,1-4.64-.26,4.34,4.34,0,0,1-2.52-1.47,1.87,1.87,0,0,1-.3-.71A.74.74,0,0,1,165.48,161.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.33 278.44 255.9 278.44 268.69 228.9 203.97 228.9 193.73 275.21 178.33 275.57 178.33 278.44",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 566.35,
    y: 338.13,
    width: 7.31,
    height: 87.63,
    transform: "translate(1140.01 763.9) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.25,342.1H622.86a11.35,11.35,0,0,0-11.35-11.35H529.6a11.35,11.35,0,0,0-11.35,11.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.9,342.33a79.27,79.27,0,0,0,12.83,0,76.34,76.34,0,0,0-12.83,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,433.71h1a31.13,31.13,0,0,1,62.25,0h1a32.16,32.16,0,1,0-64.31,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,435.31a4.83,4.83,0,1,0,4.83-4.83A4.82,4.82,0,0,0,597,435.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.46,434.64a4.83,4.83,0,1,0,4.82-4.82A4.82,4.82,0,0,0,533.46,434.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.32,425.77c0,.15,14,.27,31.25.27s31.25-.12,31.25-.27-14-.27-31.25-.27S538.32,425.62,538.32,425.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.94,251.38v64.51a15.32,15.32,0,0,1-15.32,15.32H560.91l6.75-79.83a6.83,6.83,0,0,1,6.83-6.83h44.62A6.83,6.83,0,0,1,625.94,251.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.36,330.75l.12-.19.36-.53c.33-.46.8-1.14,1.37-2a33.91,33.91,0,0,0,3.7-8.22,32.72,32.72,0,0,0,1.23-6.1,61.32,61.32,0,0,0,.2-7.16c0-5.08,0-10.64,0-16.49,0-11.68.06-22.25.08-30,0-3.8.06-6.89.08-9.08l0-2.47a5.65,5.65,0,0,1,.05-.86,4.35,4.35,0,0,1,0,.86c0,.61,0,1.43,0,2.47,0,2.19.05,5.28.09,9.08,0,7.71,0,18.28.07,30,0,5.85,0,11.41,0,16.49a60.08,60.08,0,0,1-.25,7.21,33.24,33.24,0,0,1-1.3,6.16,32.34,32.34,0,0,1-3.89,8.22c-.6.89-1.09,1.56-1.45,2A4.42,4.42,0,0,1,608.36,330.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.3,330.78a8.24,8.24,0,0,1,1.58-.09l4.3-.05c3.64,0,8.67,0,14.22,0,2.77,0,5.42,0,7.82.09a25.61,25.61,0,0,1,6.38.7,10,10,0,0,1,3.84,2,6.31,6.31,0,0,1,.83.84c.18.2.27.31.25.32s-.4-.39-1.21-1a10.25,10.25,0,0,0-3.8-1.81,26.19,26.19,0,0,0-6.3-.58l-7.82-.05c-5.55,0-10.57-.1-14.21-.17l-4.3-.12A9.08,9.08,0,0,1,581.3,330.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.66,266.34c-1.17-9.67-2.72-17.91-2.72-17.91H582s2.6,12.26,2,15.11c-.5,2.47-41.11,4.12-51.69,4.28-.63-.47-1.55.32-2.36-.39a8.25,8.25,0,0,1-1.8-2.22,12.94,12.94,0,0,1-1.45-3.28,1.09,1.09,0,0,0-2-.46c-.42.91.06,3.93,2.07,6.84s-3.26,1.4-5.19.89-8-1.83-8.6-1.35c-.92.71-.34,1.85,1.6,2.32s7.65,2.3,7.34,3.33-10.1-1.75-10.1-1.75-2-.94-2.4.24c-.72,2.13,9.9,4.28,10.91,4.46.71.13.41,1.26-.34,1.09s-9.71-3-10.46-.83c-.58,1.65,8.72,1.85,10.26,3.49s-7-.88-7.53.72c-.19.6,3.38.88,8.51,1.6a132,132,0,0,0,15.85.56c11.9.66,53.94,1.52,62.92.89C610,283.23,606.06,269.66,605.66,266.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.7,216.19s-5.77-5.89-6.89-6.12-11.93-5.66-11.93-5.66a1.85,1.85,0,0,0,.32,2.76c1.6,1.27,5.38,3.56,5.38,3.56L464.91,216s2.56,8.55,3,8.38.9-1.68.9-1.68L468,220l5.23,4.37,2.27-.26Z",
    style: {
      fill: "#ffb29d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.25,213.36a24.85,24.85,0,0,1-3.64-1.77l0,0-2.85-.76.32-.22a3.59,3.59,0,0,0,.76,2.4,9.16,9.16,0,0,0,2.91,2.42l.19.1-.07.19a6.39,6.39,0,0,0-.12,4c.28,1,.59,1.49.54,1.52a3.25,3.25,0,0,1-.81-1.43,6.26,6.26,0,0,1-.06-4.24l.12.29a8.9,8.9,0,0,1-3.12-2.54,4,4,0,0,1-.84-2.75l0-.3.29.08,2.83.85h0A27,27,0,0,1,476.25,213.36Z",
    style: {
      fill: "#eb9078"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.59,216.09a31,31,0,0,0,2.24,6.56,5,5,0,0,0,1-2.09",
    style: {
      fill: "#ffb29d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.85,220.56a3.22,3.22,0,0,1-.84,2.23l-.21.28-.17-.33a20.53,20.53,0,0,1-.94-2.11,12.55,12.55,0,0,1-1.1-4.54c.15,0,.66,2,1.58,4.35.3.78.6,1.5.87,2.11l-.38-.05A13.8,13.8,0,0,0,469.85,220.56Z",
    style: {
      fill: "#eb9078"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,212.16a8.36,8.36,0,0,1,1,2.22,10.54,10.54,0,0,1,.62,2.61,6.64,6.64,0,0,1-.46,3.29,5.26,5.26,0,0,1-.75,1.23l-.26.3-.17-.36a26.19,26.19,0,0,1-1.68-4.69,6.68,6.68,0,0,1-.33-2c.14,0,.77,2.91,2.47,6.44l-.43,0a4.69,4.69,0,0,0,.67-1.1,8.3,8.3,0,0,0,0-5.59A18.22,18.22,0,0,1,470,212.16Z",
    style: {
      fill: "#eb9078"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.7 216.19 521.68 243.93 509.72 258.88 475.54 224.06 480.7 216.19",
    style: {
      fill: "#ffb29d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.23,435l-.2-10.08,18.87-.51.46,14.74-1.17.11c-5.2.43-26.47,1.81-30,.85C508.3,439,524.23,435,524.23,435Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.51,439.14a6.55,6.55,0,0,1,2.3-4.09,6.31,6.31,0,0,1,4.37-1.49l.15,5.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.45,437.2s-5.57,1.77-4.85,2.68,22.27.31,31.76-.78l-.05-.42-25.12.91S517.55,437.22,516.45,437.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M543.61,438.66l-.32,0-.93.08-3.43.24c-2.89.18-6.9.38-11.32.51s-8.43.15-11.33.13l-3.43-.05-.94,0-.32,0a1.14,1.14,0,0,1,.32,0l.94,0,3.43,0c2.9,0,6.9-.07,11.33-.2s8.42-.3,11.31-.44l3.43-.17.93,0A1.37,1.37,0,0,1,543.61,438.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.2,439.88a7.48,7.48,0,0,0-.68-1.62,8.07,8.07,0,0,0-1.21-1.28,2.56,2.56,0,0,1,1.4,1.16A2.53,2.53,0,0,1,518.2,439.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.69,436.9c-.05,0-.33-.28-.61-.71s-.48-.8-.43-.83.33.28.62.71S523.74,436.87,523.69,436.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2,436.05c0,.05-.35-.14-.68-.42s-.57-.56-.53-.6.35.14.68.42S525.24,436,525.2,436.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.11,434.24c0,.07-.43.14-1,.16a2.3,2.3,0,0,1-1-.08,2.3,2.3,0,0,1,1-.15A2.33,2.33,0,0,1,526.11,434.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.41,433a2,2,0,0,1-1.09.35,1.89,1.89,0,0,1-1.14-.12,6.07,6.07,0,0,1,1.12-.11A6.16,6.16,0,0,1,526.41,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,435.27a3.34,3.34,0,0,1-1.22,0,7.52,7.52,0,0,1-1.3-.25,3.8,3.8,0,0,1-.74-.28.68.68,0,0,1-.31-.37.46.46,0,0,1,.17-.49,2.22,2.22,0,0,1,2.77.57,2.16,2.16,0,0,1,.41.8c.06.21.06.32,0,.33a3.11,3.11,0,0,0-.58-1,2.25,2.25,0,0,0-1-.65,1.9,1.9,0,0,0-1.44.14c-.19.15-.11.37.11.5a3.81,3.81,0,0,0,.69.27,9.89,9.89,0,0,0,1.25.29C522.54,435.25,523,435.24,523,435.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.69,435.34a1.25,1.25,0,0,1-.16-.84,1.91,1.91,0,0,1,.31-.89,1.21,1.21,0,0,1,1-.65.49.49,0,0,1,.39.55,1.43,1.43,0,0,1-.19.55,3.64,3.64,0,0,1-.55.75,1.84,1.84,0,0,1-.68.51s.23-.23.55-.62a3.39,3.39,0,0,0,.49-.74c.16-.26.26-.72,0-.77s-.61.29-.79.54a2,2,0,0,0-.32.79A4.49,4.49,0,0,0,522.69,435.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.08,433.51s-.54,0-1.39.09a5.87,5.87,0,0,0-4.83,4.07c-.27.82-.28,1.36-.33,1.36a1.43,1.43,0,0,1,0-.38,6.21,6.21,0,0,1,.18-1,5.84,5.84,0,0,1,1.84-2.86,5.72,5.72,0,0,1,3.13-1.32,4.54,4.54,0,0,1,1,0C543,433.46,543.08,433.49,543.08,433.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.91,425.71a35,35,0,0,1,.27,3.87,30.19,30.19,0,0,1,0,3.88,65.39,65.39,0,0,1-.31-7.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.08,437.36a10.33,10.33,0,0,1-2.74.35,10.8,10.8,0,0,1-2.77-.14c0-.07,1.24,0,2.76-.09S534.07,437.3,534.08,437.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.78,437.26c.05,0-.09.26-.21.55s-.18.53-.24.53-.11-.29,0-.62S537.74,437.21,537.78,437.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.13,435.48s-.07.25-.26.45-.38.33-.43.29.07-.24.26-.45S539.08,435.44,539.13,435.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.1,434.64c0,.06-.26.06-.54.17s-.47.26-.52.22.1-.31.44-.43S541.12,434.58,541.1,434.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.51,434.22c0,.06-.08.16-.24.23s-.3.07-.32,0,.08-.16.24-.23S542.49,434.16,542.51,434.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.66,381,483,372l17.06,8.09-6.26,13.35-1.09-.44c-4.83-2-24.42-10.35-27.12-12.8C462.62,377.43,478.66,381,478.66,381Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.71,390.33a6.52,6.52,0,0,1,3.9-2.6,6.35,6.35,0,0,1,4.58.65l-2.26,4.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.7,379.53s-5.77-.94-5.54.2,19.72,10.35,28.67,13.67l.16-.4-22.82-10.56S471.67,380,470.7,379.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.26,393.12,494,393l-.87-.34-3.16-1.34c-2.66-1.14-6.32-2.78-10.33-4.66s-7.58-3.69-10.16-5l-3-1.59-.82-.45-.28-.17a1.38,1.38,0,0,1,.3.13l.84.41,3.07,1.53c2.6,1.29,6.19,3.06,10.19,4.95s7.65,3.54,10.29,4.72l3.14,1.4.85.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.05,382.71a8.3,8.3,0,0,0,.12-1.75,7.47,7.47,0,0,0-.5-1.69,2.5,2.5,0,0,1,.73,1.66A2.56,2.56,0,0,1,471.05,382.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.29,382.54a2.12,2.12,0,0,1-.23-.91,2.09,2.09,0,0,1,0-.94c.07,0,.17.4.23.91S477.36,382.53,477.29,382.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,382.46c-.06,0-.24-.28-.41-.68s-.26-.75-.2-.78.24.28.41.69S479.08,382.44,479,382.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.66,381.26a2.25,2.25,0,0,1-1-.3c-.49-.23-.87-.46-.85-.52s.45.08.95.31A2.57,2.57,0,0,1,480.66,381.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.49,380.27a1.93,1.93,0,0,1-1.13-.18c-.6-.23-1-.57-1-.62a5.31,5.31,0,0,1,1,.41A6.77,6.77,0,0,1,481.49,380.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.42,380.78a3.76,3.76,0,0,1-1.1-.53,7.24,7.24,0,0,1-1-.81,3.91,3.91,0,0,1-.54-.59.65.65,0,0,1-.11-.47A.47.47,0,0,1,475,378a2.22,2.22,0,0,1,2.21,1.77,2,2,0,0,1,0,.9c0,.2-.09.31-.11.31a3.4,3.4,0,0,0-.05-1.18,2.31,2.31,0,0,0-.65-1.05,1.89,1.89,0,0,0-1.35-.53c-.24.05-.27.29-.13.49a3.78,3.78,0,0,0,.5.56,8.34,8.34,0,0,0,1,.83C477,380.54,477.43,380.74,477.42,380.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.11,380.7a1.2,1.2,0,0,1,.23-.82,2,2,0,0,1,.68-.66,1.21,1.21,0,0,1,1.18-.13.48.48,0,0,1,.1.66,1.36,1.36,0,0,1-.42.41,4,4,0,0,1-.83.42,1.69,1.69,0,0,1-.84.14s.31-.09.78-.3a3.91,3.91,0,0,0,.77-.44c.26-.16.56-.52.31-.7a1.08,1.08,0,0,0-.95.12,2,2,0,0,0-.64.57A3.87,3.87,0,0,0,477.11,380.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.12,388.29s-.47-.28-1.28-.56a6,6,0,0,0-6.16,1.45c-.6.61-.86,1.09-.9,1.07a1,1,0,0,1,.17-.35,4.85,4.85,0,0,1,.62-.83,5.72,5.72,0,0,1,6.32-1.49,4.63,4.63,0,0,1,.93.47C496,388.19,496.13,388.28,496.12,388.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.71,380.35a31.8,31.8,0,0,1-1.51,3.57,31.27,31.27,0,0,1-1.72,3.48,33.69,33.69,0,0,1,1.51-3.57A31.27,31.27,0,0,1,497.71,380.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.35,387.65a10.2,10.2,0,0,1-2.61-.93,10.84,10.84,0,0,1-2.4-1.38c0-.06,1.12.54,2.5,1.17S486.37,387.59,486.35,387.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.7,389.23c0,.06-.21.19-.44.4s-.4.39-.46.36,0-.31.31-.54S489.68,389.17,489.7,389.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.7,388.26c0,.06-.17.18-.43.28s-.49.12-.52.06.18-.18.44-.28S491.68,388.2,491.7,388.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.84,388.4c0,.05-.26-.06-.55-.09s-.54,0-.57,0,.23-.23.59-.19S493.89,388.35,493.84,388.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.29,388.66c0,.07-.15.11-.32.1s-.29-.08-.29-.14.14-.1.31-.09S495.29,388.6,495.29,388.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.4,248.1a102.61,102.61,0,0,1-10.93.33,104.3,104.3,0,0,1-10.94-.25,206.32,206.32,0,0,1,21.87-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.11,249.16l-4-20.13c-3-16.47-26.05-17.61-26.05-17.61l-18.12-.29s-13.44-1.81-21.73,7.54c-8.58,9.68-19.12,21.11-19.12,21.11l8,20.25,19.07-15.73a19.45,19.45,0,0,0-2.56,9.15c0,5.37,5.6,7.84,5.6,7.84l1.71,16.33L540.25,304l59.19-2.37a58.89,58.89,0,0,0-8.73-24.87l1.1-27.59Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.07,249.73a16,16,0,0,1,.71-2.72c.25-.83.56-1.82.94-2.91.19-.54.4-1.11.64-1.69.13-.32.3-.59.38-.85a2.45,2.45,0,0,0,.11-.87,13.13,13.13,0,0,0-.28-1.85q-.18-.92-.33-1.77c-.19-1.08-.36-2.08-.52-3a12.86,12.86,0,0,1-.34-2.8,13.4,13.4,0,0,1,.74,2.72c.2.91.41,1.91.65,3q.16.85.36,1.77a12.46,12.46,0,0,1,.3,2,3,3,0,0,1-.14,1.06c-.12.36-.29.63-.4.89-.25.57-.46,1.12-.67,1.66l-1,2.85A12.21,12.21,0,0,1,539.07,249.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M578.39,232.05c.74,11.23,1.17,21.57,1.39,32.81a8.36,8.36,0,0,0,4.22-1.32C584.58,258.74,581,244.15,578.39,232.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M599.61,299s-77.38-16.21-84.88-12.66-42,89-42,89l27.82,12,29.94-72.57s54.18,19.79,63.64,17.82S599.61,299,599.61,299Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,303.53c-1.19.39-45.95,18.79-49.11,24.71s4.6,104.14,4.6,104.14H546l-1.58-87.3,49.69-12.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.35,332.69a3.36,3.36,0,0,1-.73-.09l-2.08-.37c-1.81-.33-4.42-.85-7.63-1.53-6.43-1.36-15.27-3.41-24.91-6.17-4.82-1.4-9.37-2.85-13.48-4.26s-7.77-2.82-10.79-4.12c-1.52-.61-2.88-1.22-4.07-1.76s-2.21-1-3-1.43l-1.89-.95a3,3,0,0,1-.64-.37,3.1,3.1,0,0,1,.69.26l1.94.86c.83.38,1.86.83,3.06,1.33s2.56,1.09,4.09,1.68c3,1.24,6.72,2.56,10.81,4s8.66,2.82,13.47,4.21c9.62,2.76,18.44,4.87,24.84,6.33l7.58,1.71,2.06.47A3.44,3.44,0,0,1,594.35,332.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.93,350.8a7.16,7.16,0,0,1-.23-1.47c-.12-1.06-.26-2.41-.43-4s-.35-3.76-.55-6a26.89,26.89,0,0,1,0-7.4,11.57,11.57,0,0,1,3.72-6.4,19.58,19.58,0,0,1,5.09-3.28c1.57-.72,2.88-1.17,3.78-1.49a7.2,7.2,0,0,1,1.43-.41c0,.1-2,.8-5,2.27a20.17,20.17,0,0,0-4.9,3.3,11.21,11.21,0,0,0-3.51,6.12,28.4,28.4,0,0,0,0,7.25c.16,2.22.31,4.25.43,6s.18,3,.24,4A6.81,6.81,0,0,1,515.93,350.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.27,342.37a18.17,18.17,0,0,1,6,2.65,9.93,9.93,0,0,1-3.13-1.06A9.61,9.61,0,0,1,538.27,342.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.51,339.68a34.75,34.75,0,0,1,2,2.87c1.15,1.54,2.32,2.61,2.21,2.74a9.14,9.14,0,0,1-4.24-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.29,343.71s-.08.21-.4.4a2.94,2.94,0,0,1-1.47.35,17.14,17.14,0,0,0-2.12.05,1.47,1.47,0,0,0-1.26,1.62c0,3.74-.15,6.81-.32,6.8a38.07,38.07,0,0,1-.27-6.83,2.41,2.41,0,0,1,.49-1.45,2,2,0,0,1,1.27-.67,12.53,12.53,0,0,1,2.21.07A3.65,3.65,0,0,0,550.29,343.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.18 285.8 596.93 290.04 594.68 284.14 544.7 283.42 544.18 285.8",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.54,164c-3.87,1.25-8.36,3.82-6.13,15.93,1,5.33,2.22,10.76,5.79,14.83a2.53,2.53,0,0,0,2.07,1.14,2.62,2.62,0,0,0,1.43-1c4.06-4.42,7.52-9.65,8.62-15.55s-.55-12.56-5.2-16.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,216.54c-.13-5.57-.36-11.54-.36-11.54s-8.48-1.07-8.85-9.72-.45-23.81-.45-23.81l16.55-12.25,11.62,16,.29,41a9.4,9.4,0,0,1-9.4,9.47h0A9.4,9.4,0,0,1,553,216.54Z",
    style: {
      fill: "#ffb29d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.6,205a20.65,20.65,0,0,0,11.22-3.68s-2.64,6.3-11.08,5.8Z",
    style: {
      fill: "#eb9078"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.36,194.92a1,1,0,0,1,1-1.44,1.6,1.6,0,0,1,1.62-1.41,1.81,1.81,0,0,1,1.64,1.47,2.09,2.09,0,0,1-.92,2.05,2.49,2.49,0,0,1-2.28.17,1.8,1.8,0,0,1-1.15-1.36",
    style: {
      fill: "#eb9078"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.36,182.33a1.18,1.18,0,0,0,1.15,1.19,1.13,1.13,0,0,0,1.22-1.07,1.2,1.2,0,0,0-1.14-1.2A1.14,1.14,0,0,0,545.36,182.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.1,181c.15.16,1-.51,2.33-.51s2.21.65,2.35.49-.08-.35-.49-.65a3.33,3.33,0,0,0-1.88-.58,3.14,3.14,0,0,0-1.85.6C545.16,180.64,545,180.92,545.1,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.87,182.63a1.18,1.18,0,0,0,1.15,1.19,1.13,1.13,0,0,0,1.22-1.07,1.2,1.2,0,0,0-1.14-1.2A1.15,1.15,0,0,0,557.87,182.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.66,181.23c.15.15,1.05-.51,2.32-.51s2.22.64,2.36.49-.08-.35-.49-.65A3.34,3.34,0,0,0,560,180a3.19,3.19,0,0,0-1.85.6C557.72,180.88,557.59,181.16,557.66,181.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,190.7a8.31,8.31,0,0,0-2.07-.37c-.33,0-.64-.1-.69-.32a1.63,1.63,0,0,1,.22-1c.3-.79.62-1.62,1-2.48a43.52,43.52,0,0,0,2.17-6.5,42.9,42.9,0,0,0-2.69,6.31c-.32.87-.63,1.7-.92,2.5a1.89,1.89,0,0,0-.17,1.28.81.81,0,0,0,.54.47,2,2,0,0,0,.55.08A7.73,7.73,0,0,0,553,190.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.78,191.59c-.2,0-.21,1.37-1.39,2.36s-2.67.83-2.68,1,.33.27,1,.29a3.48,3.48,0,0,0,2.23-.78,3,3,0,0,0,1.08-2C557,191.92,556.88,191.58,556.78,191.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.09,178.38c.12.34,1.4.18,2.9.36s2.71.59,2.91.28c.08-.15-.13-.48-.61-.81a4.84,4.84,0,0,0-2.16-.76,4.72,4.72,0,0,0-2.27.27C557.31,177.94,557,178.21,557.09,178.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.57,177.29c.23.29,1.11,0,2.17,0s2,.19,2.16-.11c.09-.15,0-.44-.45-.71a2.94,2.94,0,0,0-1.75-.48,3,3,0,0,0-1.73.58C545.6,176.85,545.47,177.15,545.57,177.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.79,177.68a6.67,6.67,0,0,0,4.21-1.5c.77,2,.75,4.3,1.45,6.36s2.35,10.58,4.51,10.26c2-.3,3.38-8.89,3.89-10.82,1.39-5.36-.36-11.25-3.91-15.49-4.23-5-11.27-9.31-17.81-8.84A14.71,14.71,0,0,0,548,160.5s-3.53,2.73-3.24,6.2c.41,4.85,7.48,8,12.33,7.82l.7.67A8.38,8.38,0,0,0,563.79,177.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.25,176.09a7.16,7.16,0,0,0,2.42-3.87,22.27,22.27,0,0,0,.56-4.61c0-.45-.05-1-.48-1.14s-.77.32-1,.7a14.92,14.92,0,0,0-1.53,9.37c.09-.09-.29.24-.2.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.57,212a10.23,10.23,0,0,0,3.38-8.83c-.31-2.49-1.54-4.86-1.42-7.36.09-2,1-3.79,1.66-5.67a19.67,19.67,0,0,0,.75-9.54c-.43-2.52-1.45-5.09-3.53-6.58s-5.35-1.45-6.88.59l-.74.23a20.77,20.77,0,0,0,2.64,22.11,11.33,11.33,0,0,0,.19,15.21,12.41,12.41,0,0,0-1.56,12.43l.07.15a10.94,10.94,0,0,0-.37,14.6,10.82,10.82,0,0,0-3.68,6.33,5.9,5.9,0,0,0,3.06,6.12,7,7,0,0,0,1.88,11.8,21.72,21.72,0,0,1,3.57-2.91,3.63,3.63,0,0,1-1.64-1.58,4.56,4.56,0,0,0,2.77.87l-1.2-5.44a7.08,7.08,0,0,0-1-2.8,1.07,1.07,0,0,0-.14-.16,6.52,6.52,0,0,0,3.11-3.37c1.08-2.79.33-6-1.11-8.63,1.52-3.13,3-6.42,3-9.9a10.56,10.56,0,0,0-1-4.59,13,13,0,0,0,2.15-7A6.68,6.68,0,0,0,574.57,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.47,239.28a2.88,2.88,0,0,1-2.32.86,2.93,2.93,0,0,1-2.35-.79c.07-.14,1.06.3,2.34.27S573.4,239.14,573.47,239.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.72,226.89a20,20,0,0,0-5,4.29,20.68,20.68,0,0,0-2.88,5.89,5.22,5.22,0,0,1,.3-1.95,13,13,0,0,1,5.73-7.44A4.77,4.77,0,0,1,575.72,226.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.72,225.19a3.65,3.65,0,0,1-4.57,0c.07-.14,1,.29,2.29.28S574.65,225.06,574.72,225.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.28,223.5a13.33,13.33,0,0,0-4.81-9.68,3.71,3.71,0,0,1,1.42.89,10.31,10.31,0,0,1,3.53,7.12A3.6,3.6,0,0,1,576.28,223.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,210.59c.12.07-.41.9-1.49,1.32s-2,.18-2,0,.87-.15,1.81-.52S574.87,210.49,575,210.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.89,211.17a3.54,3.54,0,0,1-1.1-1.84,8,8,0,0,1,.23-5.17,13.68,13.68,0,0,1,2.82-4.33,7.31,7.31,0,0,1,1.57-1.45,10.21,10.21,0,0,1-1.29,1.69,16,16,0,0,0-2.61,4.28,8.36,8.36,0,0,0-.37,4.87A17.35,17.35,0,0,0,571.89,211.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.48,197.17a4.19,4.19,0,0,1-4.66-.95c.09-.12,1,.44,2.29.69S575.45,197,575.48,197.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.48,183.42a5.61,5.61,0,0,1-2.3.16,11.11,11.11,0,0,1-9-5.94,5.39,5.39,0,0,1-.76-2.18c.08,0,.36.81,1.08,2a11.95,11.95,0,0,0,8.75,5.76C578.6,183.41,579.48,183.33,579.48,183.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.71,188.56s-.19.23-.66.43a4,4,0,0,1-2.16.2,10.37,10.37,0,0,1-5.88-3.82,13.09,13.09,0,0,1-2.84-6.43,10.65,10.65,0,0,1-.1-2.14,2.46,2.46,0,0,1,.12-.78c.1,0,0,1.12.34,2.86a13.92,13.92,0,0,0,2.89,6.16,10.71,10.71,0,0,0,5.53,3.79A4.68,4.68,0,0,0,578.71,188.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.86,172.73a4.14,4.14,0,0,1-1,.47,10.79,10.79,0,0,1-2.93.67,12.12,12.12,0,0,1-4.52-.44,11.74,11.74,0,0,1-5-2.81l.26.06a13.08,13.08,0,0,1-3.53.69,13.36,13.36,0,0,1-6.8-1.4,13,13,0,0,1-4.37-3.64,12.29,12.29,0,0,1-1.87-3.34,9.07,9.07,0,0,1-.31-1c0-.23-.07-.35,0-.36a17.08,17.08,0,0,0,2.51,4.46,12.89,12.89,0,0,0,10.86,4.75,12.9,12.9,0,0,0,3.39-.65l.15,0,.11.1a11.67,11.67,0,0,0,4.72,2.75,12.45,12.45,0,0,0,4.37.54A17.71,17.71,0,0,0,576.86,172.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,165.76a3.68,3.68,0,0,1-1,.17c-.67.08-1.64.17-2.84.28l-4.21.34a27.34,27.34,0,0,1-5.22,0,17.7,17.7,0,0,1-8.74-3.53,16,16,0,0,1-2.11-1.94,3.71,3.71,0,0,1-.63-.84c.07-.07,1,1.1,3,2.49a18.51,18.51,0,0,0,8.58,3.3,30.11,30.11,0,0,0,5.12,0l4.23-.23c1.2-.06,2.18-.1,2.85-.11A4.13,4.13,0,0,1,573,165.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.45,250.57a3.24,3.24,0,0,1-2.53,1.09,3.17,3.17,0,0,1-2.64-.78,18.37,18.37,0,0,0,2.61.26A19.36,19.36,0,0,0,573.45,250.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.44,252.1a10,10,0,0,1,.14-1.57,10.67,10.67,0,0,0-.41-3.68,10.79,10.79,0,0,0-1.7-3.29c-.59-.76-1-1.16-1-1.23a3.34,3.34,0,0,1,1.27,1,8.92,8.92,0,0,1,1.91,3.38,8.66,8.66,0,0,1,.28,3.88A3.29,3.29,0,0,1,571.44,252.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.66,266.34c-1.17-9.67-2.72-17.91-2.72-17.91H582s2.6,12.26,2,15.11c-.5,2.47-41.11,4.12-51.69,4.28-.63-.47-1.55.32-2.36-.39a8.25,8.25,0,0,1-1.8-2.22,12.94,12.94,0,0,1-1.45-3.28,1.09,1.09,0,0,0-2-.46c-.42.91.06,3.93,2.07,6.84s-3.26,1.4-5.19.89-8-1.83-8.6-1.35c-.92.71-.34,1.85,1.6,2.32s7.65,2.3,7.34,3.33-10.1-1.75-10.1-1.75-2-.94-2.4.24c-.72,2.13,9.9,4.28,10.91,4.46.71.13.41,1.26-.34,1.09s-9.71-3-10.46-.83c-.58,1.65,8.72,1.85,10.26,3.49s-7-.88-7.53.72c-.19.6,3.38.88,8.51,1.6a132,132,0,0,0,15.85.56c11.9.66,53.94,1.52,62.92.89C610,283.23,606.06,269.66,605.66,266.34Z",
    style: {
      fill: "#ffb29d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.68 227.96 483.93 278.35 562.01 278.35 561.43 275.75 529.86 274.78 515.31 227.93 466.68 227.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.28,251.63c.52,2.06-.37,4.08-2,4.51s-3.33-.89-3.84-3,.36-4.08,2-4.51S500.77,249.56,501.28,251.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.69 278.34 159.69 284.87 360.99 284.87 360.99 432.11 406.49 432.11 406.49 284.87 607.32 284.87 607.32 278.34 159.69 278.34",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "353.46 435.67 352.45 385.24 371.77 382.04 368.73 435.45 353.46 435.67",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.55,435.9l-.05-1.78-16.76.42.1,5.87,1,0c4.61.15,23.46.45,26.52-.56C383.81,438.78,369.55,435.9,369.55,435.9Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.89,440.14a5.76,5.76,0,0,0-2.21-3.51,5.66,5.66,0,0,0-3.93-1.13l.11,4.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.52,437.55s5,1.32,4.41,2.16-19.66,1.25-28.09.7l0-.38,22.24-.29S375.55,437.62,376.52,437.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,440a1.64,1.64,0,0,0,.29,0l.82,0,3,.06c2.56,0,6.11,0,10,0s7.45-.24,10-.39l3-.19.82-.06.28,0h-.28l-.83,0-3,.13c-2.56.11-6.1.24-10,.32s-7.46.11-10,.11h-3.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1,440a4.34,4.34,0,0,1,1.54-2.64A2.7,2.7,0,0,0,375.1,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.12,437.6s.27-.26.51-.65.39-.73.34-.75-.28.26-.51.65S370.07,437.57,370.12,437.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,436.92s.3-.14.58-.41.48-.51.44-.55-.3.14-.58.41S368.71,436.88,368.75,436.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.86,435.36a1.82,1.82,0,0,0,.87.09,1.85,1.85,0,0,0,.88-.11,2.29,2.29,0,0,0-.88-.09A2.18,2.18,0,0,0,367.86,435.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.54,434.26a1.74,1.74,0,0,0,1,.26,1.62,1.62,0,0,0,1-.16,6.65,6.65,0,0,0-1,0A4.75,4.75,0,0,0,367.54,434.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.65,436.14a3.17,3.17,0,0,0,1.07,0,6,6,0,0,0,1.14-.27,3,3,0,0,0,.65-.29.59.59,0,0,0,.26-.33.42.42,0,0,0-.18-.43,2,2,0,0,0-2.42.63,1.92,1.92,0,0,0-.33.72.59.59,0,0,0,0,.29,3.05,3.05,0,0,1,.47-.92,1.91,1.91,0,0,1,.9-.62,1.67,1.67,0,0,1,1.28.06c.17.12.11.32-.08.44a3.15,3.15,0,0,1-.59.27,7,7,0,0,1-1.1.31C371.06,436.09,370.65,436.1,370.65,436.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.93,436.18a1,1,0,0,0,.11-.75,1.81,1.81,0,0,0-.31-.77,1.08,1.08,0,0,0-.91-.53.43.43,0,0,0-.32.5,1.16,1.16,0,0,0,.2.48,3.2,3.2,0,0,0,.52.64,1.55,1.55,0,0,0,.62.42s-.22-.19-.52-.52a3.41,3.41,0,0,1-.46-.64c-.16-.22-.27-.63,0-.68s.55.23.72.44a1.93,1.93,0,0,1,.32.69A4.32,4.32,0,0,1,370.93,436.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.84,435.45s.48-.05,1.23,0a5.43,5.43,0,0,1,2.72,1,5.31,5.31,0,0,1,1.73,2.34c.27.71.31,1.19.35,1.18a1.19,1.19,0,0,0,0-.33,4.28,4.28,0,0,0-.2-.9,5.21,5.21,0,0,0-1.75-2.45,5.13,5.13,0,0,0-2.83-1,4.74,4.74,0,0,0-.91,0A1.3,1.3,0,0,0,352.84,435.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,438.47a14.28,14.28,0,0,0,4.88-.06c0-.06-1.1,0-2.44,0S361,438.41,361,438.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.69,438.53s.09.23.21.48.18.47.24.46.08-.26-.06-.55S357.72,438.49,357.69,438.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,437s.07.21.25.38.35.28.39.24-.07-.22-.25-.39S356.46,437,356.42,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.64,436.36c0,.06.23.05.48.13s.43.21.47.17-.1-.26-.41-.36S354.62,436.31,354.64,436.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.38,436.06c0,.05.08.14.22.19s.26.05.28,0-.08-.13-.22-.18S353.4,436,353.38,436.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.71 435.35 373.39 384.22 392.81 382.04 390.28 435.23 374.71 435.35",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.94,292c18.93.12,37.88.25,56.73,2,7.52.68,15.65,1.93,20.88,7.37,4.9,5.1,6,12.63,6.94,19.64l8.26,64.13a295.7,295.7,0,0,1-78.55-2.49q.29-23.84.55-47.67l.42-7.46L309,325.57Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,316.81a47.51,47.51,0,0,1,4.24-9.06,49.19,49.19,0,0,1-4.24,9.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,338.26a17.91,17.91,0,0,1-2.84-3.26,18.86,18.86,0,0,1-2.43-3.59,17.76,17.76,0,0,1,2.84,3.27A18.41,18.41,0,0,1,396.7,338.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33,350.9a30.83,30.83,0,0,1-5.75,5.43,15.3,15.3,0,0,1,2.7-2.91A15,15,0,0,1,393.33,350.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.36,363.61a35.8,35.8,0,0,1-2.08-8.33,35.8,35.8,0,0,1,2.08,8.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,377.08a14,14,0,0,1-1.49-3.42,13.84,13.84,0,0,1-1-3.58,26.12,26.12,0,0,1,2.5,7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,342.35a18.69,18.69,0,0,1-.76,4.34,18.37,18.37,0,0,1-1.26,4.21,37.82,37.82,0,0,1,2-8.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 272.55,
    width: 77.01,
    height: 3.75,
    transform: "translate(800.27 548.84) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.58 276.29 465.02 222.16 404.89 222.16 391.81 276.29 450.58 276.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.41 272.19 449.13 272.19 461.64 224.66 407.64 224.66 395.41 272.19",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.98 233.87 405.65 247.33 441.26 247.33 445.06 233.87 408.98 233.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.55,232.09c0,.15-6.25.26-13.95.26s-14-.11-14-.26,6.25-.26,14-.26S437.55,232,437.55,232.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.32,236.44a61,61,0,0,1-11.25,0,61,61,0,0,1,11.25,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.34,236.23a26,26,0,0,1-7.33,0,26,26,0,0,1,7.33,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.52,238.88c0,.15-6.89.26-15.38.26s-15.39-.11-15.39-.26,6.89-.26,15.39-.26S440.52,238.74,440.52,238.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.09,241.11a48,48,0,0,1-10,0,48,48,0,0,1,10,0Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.76,244.29c0,.15-6.39.26-14.27.26s-14.27-.11-14.27-.26,6.39-.26,14.27-.26S437.76,244.15,437.76,244.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.75,251.19a58.62,58.62,0,0,1-11,0,58.62,58.62,0,0,1,11,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.2,251.23a27.47,27.47,0,0,1-7.54-.06,27.47,27.47,0,0,1,7.54.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,251c0,.14-.71.26-1.59.26s-1.59-.12-1.59-.26.71-.26,1.59-.26S431.5,250.84,431.5,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,254c0,.14-.78.26-1.75.26s-1.75-.12-1.75-.26.78-.26,1.75-.26S409.43,253.81,409.43,254Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.94,254a34,34,0,0,1-8.39,0,34,34,0,0,1,8.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,253.63c0,.15-5,.26-11.2.26s-11.19-.11-11.19-.26,5-.26,11.19-.26S445,253.49,445,253.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,256.82c0,.14-.81.26-1.8.26s-1.81-.12-1.81-.26.81-.27,1.81-.27S408.9,256.67,408.9,256.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.42,256.71a4.87,4.87,0,0,1-2.18.26,4.81,4.81,0,0,1-2.17-.26,4.81,4.81,0,0,1,2.17-.26A4.87,4.87,0,0,1,414.42,256.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,256.5a96,96,0,0,1-14.12,0,96,96,0,0,1,14.12,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.16,261.48a68.78,68.78,0,0,1-8.54.26,68.78,68.78,0,0,1-8.54-.26,71.19,71.19,0,0,1,8.54-.26A71.19,71.19,0,0,1,422.16,261.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.14,261.27a29,29,0,0,1-7.75,0,29,29,0,0,1,7.75,0Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.94,261.27a79.39,79.39,0,0,1-12.84,0,79.39,79.39,0,0,1,12.84,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.49,231.88c0,.14-.59.26-1.32.26s-1.33-.12-1.33-.26.59-.26,1.33-.26S443.49,231.74,443.49,231.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,230.08a16.47,16.47,0,0,1-5.83,0,16.47,16.47,0,0,1,5.83,0Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.74,228.08h-54l.91-3.42h54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.91,
    cy: 226.39,
    r: 0.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.95,
    cy: 226.39,
    r: 0.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.98,
    cy: 226.39,
    r: 0.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,248l7.71,23.22c2.08,6.27,7.56,7.35,14.17,7.35h42.89V269l-39.18-5.59L366.2,239.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.44,267l3.4-1.61s3.67-7.09,4.51-6.8,1.09,2.37-.38,5.62l4.52-1.29s9.8,4.53,9.37,5.14a2.26,2.26,0,0,1-3.37,1c-2.14-1.09-4.93-2.37-4.93-2.37l-5.29,1.51,6.81.86,6.41,5.83a3.13,3.13,0,0,1-3.92-.09l-16.64,3.57-5.21.3V269Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.57,274.71c-.07,0-.38-.45-1-1.1a5.08,5.08,0,0,0-1.21-.94,4.9,4.9,0,0,0-1.8-.47,25.29,25.29,0,0,1-5-.85,25.55,25.55,0,0,1,5.06.33,5,5,0,0,1,2,.58,4.6,4.6,0,0,1,1.25,1.11A2.89,2.89,0,0,1,436.57,274.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,275.37c-.06,0-.12-.34-.58-.44s-1.24-.18-2-.26a16,16,0,0,1-2.93-.3,6.07,6.07,0,0,1,3-.22,9.2,9.2,0,0,1,2.09.43.84.84,0,0,1,.51.53C434.06,275.29,434,275.38,434,275.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.87,162.58l-2.33,47.17,20.2,1.91,1.11-11.45s7.13,1.76,9.29-4.83c1.38-4.22,2.61-37.19,2.61-37.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,163.7c.55,4.41-5.62,7-5.62,7l-1.08,10.44a20.36,20.36,0,0,0-2.9,0c.52-4.9-5.79-3.94-6.43-.6s3,5.36,3,5.36c-2.53,3.88-3.55,5.92-7.13,9.55-3.88,3.93-6,4.25-10,4.13l-4.41-.2s-1.57-3.77-2.72-12.67c-.56-4.29-3.9-9.9-2.95-16.87C314,150,333,152.08,333,152.08,342.83,152.36,350.2,153.45,351.5,163.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,152.66c4.29.11,8.72.44,12.49,2.5s6.78,7.55,6,11.76c-.71.13-1.49.42-2.2.55-.29-.53-.65-2.49-.95-3,0,.85-.26,2.74-.25,3.58-1.25.35-2.23-.35-3.49,0a27.45,27.45,0,0,0-3.33-9.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.53,251.84l3.89,12.64L378.66,259c-.76-2.34-7.2-17.12-13.83-33.66a28.44,28.44,0,0,0-21.7-17.49,123.25,123.25,0,0,0-20.05-2c-11.73.13-26.94,5.06-29.26,16.57-1.78,8.78,2.17,23.13,2.17,42L293.21,304l58.32,2-5.91-34.72Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.74,259.71c7.32,1.49,14.84,0,22.3-.46,4.52-.27,9.54-.76,13.11,2,2.84,2.21,4,5.91,4.8,9.41,1.78,7.58,3,23.26,3.84,37.89A27.54,27.54,0,0,0,351,331.64c2.33,1.16,8.48,1.2,8.52,2l-59.8,2.45Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 327.05,
    y: 338.64,
    width: 7.31,
    height: 87.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,253.58v64.51A15.32,15.32,0,0,0,281,333.41h43V253.58a6.83,6.83,0,0,0-6.83-6.83H272.5A6.83,6.83,0,0,0,265.67,253.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.77,338.64H277.15a11.36,11.36,0,0,1,11.36-11.35h81.9a11.36,11.36,0,0,1,11.36,11.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,325.78a1.61,1.61,0,0,1,0,.5,5.76,5.76,0,0,1-.17,1.41,7.72,7.72,0,0,1-6.12,5.82,31,31,0,0,1-4.14.16l-9.4,0c-6.67,0-12.71,0-17.08-.06l-5.17-.08-1.41-.05a1.61,1.61,0,0,1-.49-.06,1.91,1.91,0,0,1,.49-.05l1.41,0,5.17-.09c4.37-.06,10.41-.09,17.08-.1h9.4a31.33,31.33,0,0,0,4.06-.1,7.4,7.4,0,0,0,3.17-1.34,7.63,7.63,0,0,0,2.83-4.1C323.92,326.47,323.89,325.78,324,325.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.12,338.87a76.34,76.34,0,0,1-12.83,0,76.34,76.34,0,0,1,12.83,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,334a18.33,18.33,0,0,1-.65-3.08c-.35-2-.82-4.87-1.37-8.43S366,314.6,364,310.32a29.57,29.57,0,0,0-3.88-6.2,28.06,28.06,0,0,0-5.83-5.26,26.26,26.26,0,0,0-7.07-3.4,26.59,26.59,0,0,0-7.22-1.25c-4.73-.11-9-.09-12.65-.15s-6.53-.11-8.54-.18a16.46,16.46,0,0,1-3.14-.21,18.88,18.88,0,0,1,3.14-.21c2-.06,4.93-.12,8.54-.17s7.89-.13,12.69-.07a27,27,0,0,1,7.49,1.23,26.73,26.73,0,0,1,7.36,3.52,28.1,28.1,0,0,1,6,5.48,29.88,29.88,0,0,1,4,6.47c.24.56.44,1.12.65,1.67.11.28.21.55.31.83l.24.83c.15.56.3,1.1.45,1.64s.2,1.08.29,1.61c.37,2.12.56,4.07.81,5.86.46,3.58.82,6.48,1,8.48A17.81,17.81,0,0,1,369,334Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,434.22h-1a31.12,31.12,0,0,0-62.24,0h-1a32.16,32.16,0,1,1,64.32,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.72,435.82A4.82,4.82,0,1,1,298.9,431,4.82,4.82,0,0,1,303.72,435.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,435.15a4.82,4.82,0,1,1-4.82-4.82A4.82,4.82,0,0,1,367.24,435.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.39,426.28c0,.15-14,.27-31.25.27s-31.26-.12-31.26-.27,14-.27,31.26-.27S362.39,426.13,362.39,426.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,199.42a68.36,68.36,0,0,0,11.93-.38,25.93,25.93,0,0,0,12.2-5.58c2-1.85,2.53-2.82,2.65-6.7l.32-5.65-5.68-15.52-14.52-1.2-13.45,6.15-1.22,20.35A8,8,0,0,0,317.7,199.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.35,189.1c0,2.31-2.09,4-4,5.29s-4.13,2.62-4.7,4.87c-1.12,4.36,4.55,7.66,5.08,12.13.4,3.26-2,6.1-3.51,9a18.45,18.45,0,0,0-.46,15.8c-6.11.53-12.26,1.06-18.4,1.29l-4.25-8.32-3.16,8.44a102,102,0,0,1-16.09-1.32c3.16-2.5,3.4-7.15,3.2-11.17s-1-11.16,1.7-14.18c1.85-2.08,4.74-3,6.64-5,2.75-2.94,1.44-4.1.09-7.3a22,22,0,0,1-1.38-11.94c.63-4,3.12-7.39,5.13-10.9s2.12-6,3.23-10.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.31,164.39a14,14,0,0,1-10.75,7.22,8.57,8.57,0,0,0,7.12,1,17,17,0,0,1-6.91,4c.87,2.24,3.53,3.2,5.92,3.37a16.6,16.6,0,0,0,11.81-3.91,15.13,15.13,0,0,0,3.6-16.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.64,163.41a5.48,5.48,0,0,0,5-3.41,9.21,9.21,0,0,0,.12-6.32,7,7,0,0,0-3.35-4.55c-2.11-1-4.69-.21-6.56,1.19a9.89,9.89,0,0,0-4,6.88,7.92,7.92,0,0,0,3.18,7.16,6.61,6.61,0,0,0,7.66-.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28,179a20.59,20.59,0,0,0,4.91.69,15.14,15.14,0,0,0,5.25-1,13.87,13.87,0,0,0,8.64-9.19,15.47,15.47,0,0,0,.65-5.3,20,20,0,0,0-1-4.86s.08.1.18.31a8.64,8.64,0,0,1,.4.92,13.34,13.34,0,0,1,.79,3.61,15,15,0,0,1-.56,5.46,14.75,14.75,0,0,1-3.3,5.85,14.54,14.54,0,0,1-5.64,3.65,15.14,15.14,0,0,1-5.41.9,13.57,13.57,0,0,1-3.65-.56,8.49,8.49,0,0,1-1-.34A1,1,0,0,1,303.28,179Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,174.56a14.23,14.23,0,0,0,6.84-8.93,3.93,3.93,0,0,1-.22,1.73,10.88,10.88,0,0,1-5,6.54A4.08,4.08,0,0,1,311.29,174.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,155.05a2.21,2.21,0,0,1,.39-.78,5.77,5.77,0,0,1,1.76-1.63,6.61,6.61,0,0,1,3.44-.94,7.12,7.12,0,0,1,4.12,1.45,8.18,8.18,0,0,1,2.68,3.44,9.28,9.28,0,0,1,.67,3.49,9.45,9.45,0,0,1-.29,2.36,2.46,2.46,0,0,1-.3.82,23.31,23.31,0,0,0,.22-3.17,9.48,9.48,0,0,0-.75-3.31,7.74,7.74,0,0,0-2.54-3.21,6.78,6.78,0,0,0-3.81-1.39,6.53,6.53,0,0,0-3.25.78A7.78,7.78,0,0,0,307.89,155.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,162.4c.08,0,.77,1.37,2.1,3.5a16.79,16.79,0,0,0,2.76,3.39,9.8,9.8,0,0,0,4.67,2.38,29.31,29.31,0,0,0,5.35.54,23.65,23.65,0,0,0,4.39-.11,9.82,9.82,0,0,0,3.76-1.38,3.08,3.08,0,0,1-.85.7,8.26,8.26,0,0,1-2.85,1,21.36,21.36,0,0,1-4.46.23,28.25,28.25,0,0,1-5.46-.51,10,10,0,0,1-4.88-2.54,16,16,0,0,1-2.74-3.54c-.64-1.1-1.09-2-1.39-2.67A4.31,4.31,0,0,1,322.86,162.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,162.4a8.82,8.82,0,0,1,.55,1.14c.33.73.83,1.79,1.49,3.07s1.47,2.81,2.4,4.47a31.78,31.78,0,0,0,3.37,5.16,16.9,16.9,0,0,0,4.65,4,12.38,12.38,0,0,0,9.31,1.26s-.1.07-.3.15a6.64,6.64,0,0,1-.89.29,10.25,10.25,0,0,1-3.45.23,12.85,12.85,0,0,1-4.91-1.51,16.88,16.88,0,0,1-4.81-4,29.93,29.93,0,0,1-3.39-5.27c-.91-1.68-1.7-3.22-2.31-4.53s-1.07-2.4-1.35-3.17A4.81,4.81,0,0,1,322.86,162.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,161a5.91,5.91,0,0,1,1.06-1,25.32,25.32,0,0,1,3.23-2.16,22.07,22.07,0,0,1,5.38-2.15,17.34,17.34,0,0,1,7.08-.28,14.05,14.05,0,0,1,6.49,2.85,12.56,12.56,0,0,1,3.53,4.6,10.63,10.63,0,0,1,.9,3.8,8.09,8.09,0,0,1,0,1.07c0,.24-.05.36-.07.36a12.74,12.74,0,0,0-1.14-5.07,12.44,12.44,0,0,0-3.49-4.38,13.84,13.84,0,0,0-6.27-2.72,17.34,17.34,0,0,0-6.89.24,23.33,23.33,0,0,0-5.31,2,31.39,31.39,0,0,0-3.29,2A10.15,10.15,0,0,1,320.84,161Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,152.19a18.12,18.12,0,0,0-11.2,6.25,5,5,0,0,1,1.09-1.62,13.86,13.86,0,0,1,3.68-3,13.66,13.66,0,0,1,4.47-1.57A5.07,5.07,0,0,1,333.54,152.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.37,165.55a14.71,14.71,0,0,0,2.62.24,7.09,7.09,0,0,0,6.75-8.62,14.39,14.39,0,0,0-.86-2.49,2.17,2.17,0,0,1,.46.57,6.47,6.47,0,0,1,.76,1.84,7.2,7.2,0,0,1-7.11,9.06,6.24,6.24,0,0,1-2-.29A2,2,0,0,1,312.37,165.55Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.74,236.62a4,4,0,0,1-.34-.69c-.2-.46-.49-1.14-.85-2a39.71,39.71,0,0,1-2.36-7.72,20.34,20.34,0,0,1-.25-5.59,14.46,14.46,0,0,1,1.95-6.13c1.16-1.94,2.91-3.68,3.38-6s-.5-4.8-1.75-7c-.62-1.13-1.31-2.2-1.95-3.31a27.72,27.72,0,0,1-1.65-3.38,13.71,13.71,0,0,1-1.12-7,13,13,0,0,1,2.73-5.82,20.85,20.85,0,0,0,2.84-4.71,17.79,17.79,0,0,0,1-4.41,33.74,33.74,0,0,0,.21-3.44c0-.91,0-1.64,0-2.19a3.69,3.69,0,0,1,0-.76,4.12,4.12,0,0,1,.07.76c0,.5.07,1.24.08,2.19a31.65,31.65,0,0,1-.12,3.47,17.38,17.38,0,0,1-1,4.52,20.68,20.68,0,0,1-2.83,4.82,12.6,12.6,0,0,0-2.6,5.63,13.3,13.3,0,0,0,1.11,6.76,27.4,27.4,0,0,0,1.63,3.31c.62,1.09,1.32,2.17,2,3.31a17.41,17.41,0,0,1,1.56,3.57,7.79,7.79,0,0,1,.23,3.8,9.22,9.22,0,0,1-1.52,3.35c-.66,1-1.37,1.89-1.95,2.83a14.18,14.18,0,0,0-1.93,5.92,20.59,20.59,0,0,0,.18,5.49,43.74,43.74,0,0,0,2.19,7.71c.32.85.57,1.54.76,2A5.54,5.54,0,0,1,321.74,236.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,179.08a2.59,2.59,0,0,1-.35.55l-1.07,1.53a24.46,24.46,0,0,0-3.18,6,12.91,12.91,0,0,0-.68,4.59,9.86,9.86,0,0,0,.46,2.53,15.39,15.39,0,0,0,1.14,2.5c.88,1.66,2.09,3.44,2.19,5.66a6.22,6.22,0,0,1-.79,3.17,11.79,11.79,0,0,1-2,2.66,53,53,0,0,0-4.59,4.49,9.49,9.49,0,0,0-1.9,5.44,26.61,26.61,0,0,0,.37,5.37,40.81,40.81,0,0,1,.5,4.73,10.88,10.88,0,0,1-1.66,6.63,6.32,6.32,0,0,1-1.28,1.38,3.06,3.06,0,0,1-.4.28c-.09.06-.14.09-.15.08a8.72,8.72,0,0,0,1.66-1.85,10.9,10.9,0,0,0,1.46-6.5,41.1,41.1,0,0,0-.56-4.68,27.2,27.2,0,0,1-.42-5.46,9.89,9.89,0,0,1,2-5.73,52,52,0,0,1,4.61-4.54c1.51-1.53,2.75-3.43,2.67-5.46s-1.21-3.76-2.1-5.44a15.68,15.68,0,0,1-1.16-2.59,10,10,0,0,1-.45-2.65A13,13,0,0,1,309,187a22.88,22.88,0,0,1,3.37-6c.48-.65.87-1.14,1.15-1.47A3.74,3.74,0,0,1,314,179.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,236s-.06,0-.17-.08a5.18,5.18,0,0,1-.48-.3,6.2,6.2,0,0,1-1.49-1.6,10.56,10.56,0,0,1-1.13-7.79,37.53,37.53,0,0,1,1.6-5.28,27.76,27.76,0,0,0,1.61-6,19.38,19.38,0,0,0-.38-6.83,21.1,21.1,0,0,0-3-6.73,23.58,23.58,0,0,1-3.31-6.76,21.82,21.82,0,0,1-.48-7c.34-4.46,1.2-8.38,1.1-11.73a17,17,0,0,0-1.63-7.65,19.37,19.37,0,0,0-1.61-2.4,8.47,8.47,0,0,1,1.79,2.31,16.56,16.56,0,0,1,1.81,7.74c.15,3.39-.67,7.36-1,11.76a21.58,21.58,0,0,0,.49,6.84,23.32,23.32,0,0,0,3.27,6.62,21.63,21.63,0,0,1,3,6.88,19.92,19.92,0,0,1,.36,7,28.23,28.23,0,0,1-1.68,6.12,38.5,38.5,0,0,0-1.65,5.2,10.53,10.53,0,0,0,.94,7.61A7.51,7.51,0,0,0,332.75,236Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,435.88l-.05-1.78-16.77.41.11,5.87,1,.05c4.61.15,23.46.44,26.51-.56C405.36,438.75,391.1,435.88,391.1,435.88Z",
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.44,440.12a5.76,5.76,0,0,0-2.21-3.51,5.62,5.62,0,0,0-3.93-1.13l.1,4.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.07,437.53s5,1.32,4.4,2.15-19.66,1.26-28.08.7l0-.37,22.23-.3S397.1,437.59,398.07,437.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,440l.29,0,.82,0,3,.07c2.56,0,6.1,0,10-.05s7.45-.23,10-.38l3-.19.83-.07.28,0a1.29,1.29,0,0,0-.29,0l-.82,0-3,.13c-2.56.11-6.1.24-10,.32s-7.45.1-10,.1h-3.86A.94.94,0,0,0,374.15,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.64,440a7.83,7.83,0,0,1,.54-1.46,6.41,6.41,0,0,1,1-1.18,2.68,2.68,0,0,0-1.55,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.66,437.58s.28-.26.52-.65a2,2,0,0,0,.34-.76s-.28.27-.52.65A2,2,0,0,0,391.66,437.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,436.9s.3-.14.58-.41.48-.51.44-.55-.3.14-.58.4S390.26,436.86,390.3,436.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.41,435.34a3.84,3.84,0,1,0,.87-.11A1.82,1.82,0,0,0,389.41,435.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.09,434.23a1.59,1.59,0,0,0,1,.27,1.7,1.7,0,0,0,1-.16,5.9,5.9,0,0,0-1,0A7.21,7.21,0,0,0,389.09,434.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,436.11a2.72,2.72,0,0,0,1.07,0,6,6,0,0,0,1.14-.27,3,3,0,0,0,.65-.29.53.53,0,0,0,.25-.34.42.42,0,0,0-.17-.42,2,2,0,0,0-2.42.63,1.92,1.92,0,0,0-.33.72c0,.18,0,.29,0,.29a2.84,2.84,0,0,1,.46-.93,2,2,0,0,1,.91-.61,1.68,1.68,0,0,1,1.28.06c.17.12.11.32-.08.44a3.15,3.15,0,0,1-.59.27,7,7,0,0,1-1.1.31C392.61,436.07,392.2,436.08,392.2,436.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.48,436.16a1.1,1.1,0,0,0,.11-.75,2,2,0,0,0-.31-.77,1.08,1.08,0,0,0-.91-.53.43.43,0,0,0-.32.5,1.15,1.15,0,0,0,.19.48,3.49,3.49,0,0,0,.52.63,1.61,1.61,0,0,0,.63.42s-.22-.18-.52-.52a3.82,3.82,0,0,1-.47-.63c-.15-.22-.26-.63,0-.68s.55.23.72.44a1.63,1.63,0,0,1,.31.69A3.83,3.83,0,0,1,392.48,436.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,435.43s.48-.05,1.23,0a5.22,5.22,0,0,1,4.45,3.39c.27.71.31,1.19.34,1.18s0-.12,0-.34a4.51,4.51,0,0,0-.21-.89,5.07,5.07,0,0,0-1.74-2.45,5.16,5.16,0,0,0-2.83-1,4.13,4.13,0,0,0-.92,0A.9.9,0,0,0,374.39,435.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,438.44a8.91,8.91,0,0,0,2.44.19,9.26,9.26,0,0,0,2.43-.25c0-.06-1.09,0-2.44.05S382.51,438.38,382.51,438.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,438.51s.1.23.21.48.19.46.24.46.09-.27-.05-.55S379.27,438.47,379.23,438.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,437s.07.21.25.39.35.27.39.23-.08-.21-.25-.38S378,437,378,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.19,436.34c0,.06.23.05.48.13s.43.21.47.17-.1-.27-.41-.36S376.17,436.29,376.19,436.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.92,436s.08.13.22.18.27,0,.29,0-.08-.14-.22-.19S374.94,436,374.92,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.57,378.9c-.14,0,.36-9,1.12-20S370.18,339,370.32,339s-.35,8.95-1.11,20S367.71,378.91,367.57,378.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21,381.18a12,12,0,0,1-.17-1.65c-.07-1.16-.17-2.67-.3-4.5-.24-3.81-.61-9-1.13-14.84s-1.09-11-1.53-14.8c-.2-1.83-.38-3.34-.51-4.48a9.68,9.68,0,0,1-.12-1.66,11,11,0,0,1,.32,1.63c.18,1.05.41,2.57.68,4.46.52,3.78,1.15,9,1.68,14.8s.83,11.06,1,14.87c.08,1.9.12,3.44.14,4.51A9.49,9.49,0,0,1,377.21,381.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.25,338.08a46.08,46.08,0,0,1-31.18,23.1c-2.72.54-5.7.79-8.1-.6-3.27-1.9-4.28-6.17-4.24-9.95s0-8.94,0-12.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.12,274.14c0-.14,5-.92,11.18-1.73s11.23-1.35,11.24-1.21-5,.92-11.17,1.73S323.14,274.28,323.12,274.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39,272.29a8.71,8.71,0,0,1-1.69-1.14L335,269.8a2.22,2.22,0,0,1-.85-1.16,1.56,1.56,0,0,1,.55-1.5,1.84,1.84,0,0,1,1.5-.46,2.29,2.29,0,0,1,1.26.68,3.34,3.34,0,0,1,.89,2.13,4.44,4.44,0,0,1-.23,2.05c-.09,0,0-.8-.13-2a3.09,3.09,0,0,0-.87-1.83,1.48,1.48,0,0,0-2.08-.17,1.08,1.08,0,0,0-.39,1,1.76,1.76,0,0,0,.66.9l1.67,1.43A7.76,7.76,0,0,1,338.39,272.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,272.34a3.5,3.5,0,0,1,.47-1.67,7.57,7.57,0,0,1,1-1.6,6.7,6.7,0,0,1,.79-.82,1.87,1.87,0,0,1,1.28-.43.77.77,0,0,1,.66.5.94.94,0,0,1-.06.76,4.51,4.51,0,0,1-.7.93,7.66,7.66,0,0,1-1.45,1.23,3.6,3.6,0,0,1-1.58.72c0-.08.55-.37,1.36-1a9.31,9.31,0,0,0,1.31-1.25,4.2,4.2,0,0,0,.6-.82c.13-.28,0-.51-.2-.54-.64-.05-1.2.57-1.65,1.05a8.28,8.28,0,0,0-1.07,1.46C338,271.73,337.8,272.36,337.72,272.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.26,382.75a53.78,53.78,0,0,1,3.84-9.84,25.69,25.69,0,0,1-1.68,5A27.55,27.55,0,0,1,369.26,382.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,377.51a14.88,14.88,0,0,1-4.14-2.82,15,15,0,0,1-3.38-3.7c.11-.1,1.65,1.52,3.72,3.31S351.7,377.38,351.61,377.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,354.53a14,14,0,0,1-2.45-3,14.48,14.48,0,0,1-2-3.3,14.73,14.73,0,0,1,2.45,3A14.93,14.93,0,0,1,357.13,354.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.25,322.68a21.36,21.36,0,0,1-3.11-3.49,20.89,20.89,0,0,1-2.69-3.81,21.06,21.06,0,0,1,3.1,3.49A21.28,21.28,0,0,1,348.25,322.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,318.64a21.13,21.13,0,0,1-4.63.44,21.56,21.56,0,0,1-4.65-.07,20.16,20.16,0,0,1,4.63-.45A20.39,20.39,0,0,1,369.84,318.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,305.7a12.4,12.4,0,0,1-2-3,12.81,12.81,0,0,1-1.54-3.28,12.4,12.4,0,0,1,2,3A13.24,13.24,0,0,1,374.84,305.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38,302.91a13.9,13.9,0,0,1-3.3,1.84,14.3,14.3,0,0,1-3.53,1.37,27.79,27.79,0,0,1,6.83-3.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.73,303.91a137.5,137.5,0,0,1-8.56-6.41,21.55,21.55,0,0,1,4.53,2.87A21.28,21.28,0,0,1,339.73,303.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,279.67c.05.15-2.24,1-4.9,2.32s-4.68,2.73-4.77,2.6a22.2,22.2,0,0,1,9.67-4.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27,261.82a18.79,18.79,0,0,1-3.32-2.94,19.39,19.39,0,0,1-2.95-3.31,19,19,0,0,1,3.32,2.94A18.57,18.57,0,0,1,334.27,261.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,248.62a11.45,11.45,0,0,1-2.7,2.12,11.19,11.19,0,0,1-3,1.68,22.52,22.52,0,0,1,5.68-3.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,246.29a16,16,0,0,1-2.79-2.93,15.6,15.6,0,0,1-2.39-3.27,15.85,15.85,0,0,1,2.79,2.94A15.55,15.55,0,0,1,336.71,246.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,227.17a32.25,32.25,0,0,1-3.94,2.24,34.57,34.57,0,0,1-4,2.16A13.82,13.82,0,0,1,348.4,229,14.35,14.35,0,0,1,352.6,227.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,239.12a14.21,14.21,0,0,1,.9-3.77,14.37,14.37,0,0,1,1.39-3.61,29.09,29.09,0,0,1-2.29,7.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75,252.73a10.69,10.69,0,0,1-3.84-1.77,10.48,10.48,0,0,1-3.19-2.75c.1-.11,1.54,1.08,3.48,2.32S364.8,252.59,364.75,252.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.89,220.22a21.28,21.28,0,0,1,2.21-4.13,21.72,21.72,0,0,1,2.65-3.87,20.23,20.23,0,0,1-2.21,4.14A21.85,21.85,0,0,1,341.89,220.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,242.19a29.09,29.09,0,0,1-5.45-.79,28,28,0,0,1-5.36-1.3,29.09,29.09,0,0,1,5.45.79A28,28,0,0,1,319.06,242.19Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.83,
    y: 153.54,
    width: 74.16,
    height: 56.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 166.76,
    width: 8.66,
    height: 34.5,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.05,
    y: 164.14,
    width: 8.66,
    height: 37.11,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.24,
    y: 168.74,
    width: 8.66,
    height: 32.51,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.24,
    y: 168.74,
    width: 8.66,
    height: 32.51,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.22,
    y: 173.81,
    width: 8.66,
    height: 27.44,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 166.76,
    width: 8.66,
    height: 34.5,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.54,201.38c0,.14-14.24.26-31.81.26s-31.8-.12-31.8-.26,14.24-.26,31.8-.26S460.54,201.23,460.54,201.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.92,168.89c0,.06-1-.12-2.77,0A16.42,16.42,0,0,0,447,171a15.12,15.12,0,0,0-4,3.27c-1.24,1.39-2.35,3.07-3.67,4.75a13.59,13.59,0,0,1-5.12,4.32,18.5,18.5,0,0,1-7.05,1.39c-2.46.09-4.85,0-7.14.07a33,33,0,0,0-6.53.89,19.54,19.54,0,0,0-5.47,2.27,14.21,14.21,0,0,0-3.81,3.45,12.16,12.16,0,0,0-2.57,6.92,15.81,15.81,0,0,0,.29,2.75,7.57,7.57,0,0,1-.5-2.75,12.1,12.1,0,0,1,2.49-7.14,14.14,14.14,0,0,1,3.87-3.59,19.52,19.52,0,0,1,5.58-2.37,32.51,32.51,0,0,1,6.63-.94c2.32-.11,4.71,0,7.14-.08a18.19,18.19,0,0,0,6.86-1.33,13.37,13.37,0,0,0,5-4.16c1.31-1.64,2.43-3.33,3.71-4.74a15.58,15.58,0,0,1,4.13-3.3,16.12,16.12,0,0,1,7.32-2,13.64,13.64,0,0,1,2.07.11A3.73,3.73,0,0,1,456.92,168.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,177.24a1.77,1.77,0,0,1-.46,0h-1.35l-5.11,0-18.28-.3h-.22v-.22c0-7.77,0-17,0-26.85,0-14.36.06-27.36.08-36.82,0-4.68.06-8.48.08-11.16,0-1.28,0-2.3.05-3l0-.79a.8.8,0,0,1,0-.27.94.94,0,0,1,0,.27l0,.79c0,.73,0,1.75,0,3,0,2.68.05,6.48.09,11.16,0,9.46,0,22.46.07,36.82,0,9.86,0,19.08,0,26.85l-.22-.22,18.28.48,5.11.17,1.34.06A3.15,3.15,0,0,1,391.56,177.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.09,134.56a4.66,4.66,0,0,1-.65.05l-1.87,0-6.89.08-22.73.08-13.16,0,.24-.23c0,5.56-.07,10.28-.1,13.69,0,1.62-.05,2.93-.07,3.9,0,.41,0,.75,0,1a.18.18,0,1,1-.08,0c0-.28,0-.62,0-1,0-1,0-2.28-.06-3.9,0-3.41-.06-8.13-.1-13.69v-.24h.24l13.16,0,22.73.07,6.89.09,1.87,0A2.74,2.74,0,0,1,500.09,134.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,196.22a1.41,1.41,0,0,1-.36,0l-1.06,0h-4l-14.89-.05-49.12-.37-39.07-.39h-.14l-.06-.13L273.41,175,271,169.36l-.62-1.49a3.6,3.6,0,0,1-.18-.52,3.6,3.6,0,0,1,.25.49c.16.36.38.85.67,1.47.58,1.32,1.42,3.21,2.49,5.62,2.14,4.88,5.18,11.84,8.85,20.23l-.2-.13,39.08.3,49.11.52,14.89.22,4.05.09,1.05,0A1.65,1.65,0,0,1,390.83,196.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,195.45A4.55,4.55,0,1,1,285,190.9,4.55,4.55,0,0,1,289.49,195.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.46,169.28H246.09a6.94,6.94,0,0,1-6.94-6.94h0a6.94,6.94,0,0,1,6.94-6.94h27.37a6.94,6.94,0,0,1,6.94,6.94h0A6.94,6.94,0,0,1,273.46,169.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.85,
    y: 92.66,
    width: 63.75,
    height: 42.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.71,
    y: 105.42,
    width: 42.33,
    height: 16.81,
    style: {
      fill: "#D2232A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,106.14a92.37,92.37,0,0,1-9.9.26,92.65,92.65,0,0,1-9.91-.26,95.91,95.91,0,0,1,9.91-.26A95.62,95.62,0,0,1,283.89,106.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,109.21a90.68,90.68,0,0,1-9.9.27,91,91,0,0,1-9.91-.27A95.91,95.91,0,0,1,274,109,95.62,95.62,0,0,1,283.89,109.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,112.29a95.62,95.62,0,0,1-9.9.26,95.91,95.91,0,0,1-9.91-.26A92.65,92.65,0,0,1,274,112,92.37,92.37,0,0,1,283.89,112.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,115.36a95.62,95.62,0,0,1-9.9.26,95.91,95.91,0,0,1-9.91-.26,92.65,92.65,0,0,1,9.91-.26A92.37,92.37,0,0,1,283.89,115.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,118.43a95.62,95.62,0,0,1-9.9.26,95.91,95.91,0,0,1-9.91-.26,92.65,92.65,0,0,1,9.91-.26A92.37,92.37,0,0,1,283.89,118.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.72,121.5a33.25,33.25,0,0,1-5.82.26,33.25,33.25,0,0,1-5.82-.26,32.12,32.12,0,0,1,5.82-.26A32.12,32.12,0,0,1,275.72,121.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.09,98.87c0,.15-14.16.26-31.62.26s-31.62-.11-31.62-.26,14.15-.26,31.62-.26S320.09,98.73,320.09,98.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.7,137.53a4.36,4.36,0,0,1,0-.46c0-.33,0-.75,0-1.29,0-1.16,0-2.79-.06-4.84,0-4.18-.06-10.07-.11-17.12l.22.23-23.71,0,.26-.26h0v6.38c0,2.09,0,4.14,0,6.13,0,4,0,7.73,0,11.18l-.23-.22,17.12.11,4.84.06,1.29,0,.46,0a1.93,1.93,0,0,1-.41,0l-1.25,0-4.79.06-17.26.12h-.22v-.23c0-3.45,0-7.2,0-11.18,0-2,0-4,0-6.13v-6.38h0l.26-.26,23.71,0h.23v.22c-.05,7.11-.09,13.05-.12,17.26,0,2,0,3.64-.06,4.79,0,.52,0,.93,0,1.25A1.93,1.93,0,0,1,434.7,137.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.55,
    y: 103.67,
    width: 11.86,
    height: 11.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.3,141.5H503.93a6.94,6.94,0,0,1-6.94-6.94h0a6.93,6.93,0,0,1,6.94-6.94H531.3a6.94,6.94,0,0,1,6.94,6.94h0A6.94,6.94,0,0,1,531.3,141.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.66,
    cy: 134.65,
    r: 4.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.86,
    cy: 176.09,
    r: 4.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.74,
    y: 91.93,
    width: 41.25,
    height: 13.88,
    rx: 6.94,
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.0652e0a969449bdfd17f53d414b6aade.svg";
export { ForwardRef as ReactComponent };